import { Injectable, ɵɵdefineInjectable, Component, EventEmitter, Output, ɵɵinject, ViewChild, Input, ContentChild, HostListener, NgModule, Pipe, Directive } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DxDataGridComponent, DxScrollViewModule, DxBoxModule, DxDataGridModule, DxToolbarModule, DxButtonModule, DxSelectBoxModule, DxSwitchModule, DxFileUploaderModule, DxPopupModule, DxNavBarModule, DxTextBoxModule } from 'devextreme-angular';
import { ImageCropperModule } from 'ngx-image-cropper';
import { WebcamUtil, WebcamModule } from 'ngx-webcam';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver';
import { plainToClass, classToPlain } from 'class-transformer';
import { alert, custom } from 'devextreme/ui/dialog';
import { Breakpoints, BreakpointObserver } from '@angular/cdk/layout';
import { Observable, Subject, of } from 'rxjs';
import notify from 'devextreme/ui/notify';
import { DeviceDetectorService } from 'ngx-device-detector';
import * as moment$1 from 'moment-timezone';
import { tz } from 'moment-timezone';
import { DomSanitizer } from '@angular/platform-browser';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCCommonService {
}
CCCommonService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ CCCommonService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CCCommonService_Factory() { return new CCCommonService(); }, token: CCCommonService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCCommonComponent {
}
CCCommonComponent.decorators = [
    { type: Component, args: [{
                selector: 'cc-common',
                template: `
        <p>cc-common works!</p>
    `
            }] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCScreenService {
    /**
     * @param {?} breakpointObserver
     */
    constructor(breakpointObserver) {
        this.breakpointObserver = breakpointObserver;
        this.changed = new EventEmitter();
        this.resized = new EventEmitter();
        this.breakpointObserver
            .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large])
            .subscribe((/**
         * @return {?}
         */
        () => this.changed.next()));
        /** @type {?} */
        let timerId;
        window.addEventListener('resize', (/**
         * @return {?}
         */
        () => {
            clearTimeout(timerId);
            timerId = setTimeout((/**
             * @return {?}
             */
            () => {
                this.resized.next();
                clearTimeout(timerId);
            }), 750);
        }));
    }
    /**
     * @return {?}
     */
    isLargeScreen() {
        return (this.breakpointObserver.isMatched(Breakpoints.Large) ||
            this.breakpointObserver.isMatched(Breakpoints.XLarge));
    }
    /**
     * @return {?}
     */
    isMediumScreen() {
        return this.breakpointObserver.isMatched(Breakpoints.Medium);
    }
    /**
     * @return {?}
     */
    isSmallScreen() {
        return (this.breakpointObserver.isMatched(Breakpoints.Small) ||
            this.breakpointObserver.isMatched(Breakpoints.XSmall));
    }
    /**
     * @return {?}
     */
    isXSmallScreen() {
        return this.breakpointObserver.isMatched(Breakpoints.XSmall);
    }
    /**
     * @return {?}
     */
    get sizes() {
        return {
            'screen-x-small': this.isXSmallScreen(),
            'screen-small': this.isSmallScreen(),
            'screen-medium': this.isMediumScreen(),
            'screen-large': this.isLargeScreen()
        };
    }
    /**
     * @return {?}
     */
    get getCurrentScreenSize() {
        if (this.isXSmallScreen()) {
            return 'screen-x-small';
        }
        else if (this.isSmallScreen()) {
            return 'screen-small';
        }
        else if (this.isMediumScreen()) {
            return 'screen-medium';
        }
        else if (this.isLargeScreen()) {
            return 'screen-large';
        }
        // return large screen as default
        return 'lg';
    }
}
CCScreenService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CCScreenService.ctorParameters = () => [
    { type: BreakpointObserver }
];
CCScreenService.propDecorators = {
    changed: [{ type: Output }],
    resized: [{ type: Output }]
};
/** @nocollapse */ CCScreenService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CCScreenService_Factory() { return new CCScreenService(ɵɵinject(BreakpointObserver)); }, token: CCScreenService, providedIn: "root" });
if (false) {
    /** @type {?} */
    CCScreenService.prototype.changed;
    /** @type {?} */
    CCScreenService.prototype.resized;
    /**
     * @type {?}
     * @private
     */
    CCScreenService.prototype.breakpointObserver;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCDataGridPagingConfig {
    constructor() {
        this.visible = true;
        this.defaultPageSize = '50';
        this.allowedPageSizes = ['5', '10', '15', '20', '25', '50', '100', 'All'];
        this.showPageSizeSelector = true;
        this.showNavigationButtons = true;
        this.showInfo = true;
        this.toolbarItems = [];
    }
}
if (false) {
    /** @type {?} */
    CCDataGridPagingConfig.prototype.visible;
    /** @type {?} */
    CCDataGridPagingConfig.prototype.defaultPageSize;
    /** @type {?} */
    CCDataGridPagingConfig.prototype.allowedPageSizes;
    /** @type {?} */
    CCDataGridPagingConfig.prototype.showPageSizeSelector;
    /** @type {?} */
    CCDataGridPagingConfig.prototype.showNavigationButtons;
    /** @type {?} */
    CCDataGridPagingConfig.prototype.showInfo;
    /** @type {?} */
    CCDataGridPagingConfig.prototype.toolbarItems;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DataGridPagerComponent {
    /**
     * @param {?} screenService
     */
    constructor(screenService) {
        this.screenService = screenService;
        this.hasGrouping = false;
        this.onFirstPage = (/**
         * @return {?}
         */
        () => {
            this.selectedPage = this.pageNumbers[0];
        });
        this.onPreviousPage = (/**
         * @return {?}
         */
        () => {
            this.selectedPage -= 1;
        });
        this.onNextPage = (/**
         * @return {?}
         */
        () => {
            this.selectedPage += 1;
        });
        this.onLastPage = (/**
         * @return {?}
         */
        () => {
            this.selectedPage = this.pageNumbers[this.pageNumbers.length - 1];
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.isAllPageSize = false;
        this.pageInfoText = '';
        this.pageSize = this.pagingConfig.defaultPageSize.toString();
        /** @type {?} */
        const allowedPageSizes = [];
        this.pagingConfig.allowedPageSizes.forEach((/**
         * @param {?} r
         * @return {?}
         */
        (r) => {
            allowedPageSizes.push(r.toString());
        }));
        this.pagingConfig.allowedPageSizes = allowedPageSizes;
        this.showToolbar = this.pagingConfig.visible || !!this.toolbarItems.length;
        this.totalCount = !!this.dataSource ? this.dataSource.length : 0;
        this.isSmallScreen = this.screenService.isSmallScreen();
        this.screenService.changed.subscribe((/**
         * @return {?}
         */
        () => {
            this.isSmallScreen = this.screenService.isSmallScreen();
        }));
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (!!this.pagingToolbar && !!this.pagingToolbar.instance && !!changes.toolbarItems) {
            this.pagingToolbar.instance.option('items', this.toolbarItems);
        }
        if (!!changes.dataSource && !!this.dataSource && !!this.pagingConfig.defaultPageSize) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const pageSize = this.pageSize;
                this.pageSize = null;
                this.onPageSizeChange({ value: pageSize });
            }), 250);
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.dataGrid.instance.on('rowExpanded', this.onGridRowsRepaint.bind(this));
        this.dataGrid.instance.on('rowCollapsed', this.onGridRowsRepaint.bind(this));
    }
    /**
     * @return {?}
     */
    onGridRowsRepaint() {
        /** @type {?} */
        const pageSize = this.pageSize;
        this.pageSize = null;
        this.onPageSizeChange({ value: pageSize });
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onPageSizeChange(e) {
        if (e.value !== this.pageSize) {
            /** @type {?} */
            const instance = this.dataGrid.instance;
            if (e.value !== 'All') {
                /** @type {?} */
                const pageSize = parseInt(e.value);
                if (this.isAllPageSize) {
                    this.isAllPageSize = false;
                    instance.option({
                        dataSource: this.dataSource,
                        paging: { enabled: true, pageSize, pageIndex: 0 },
                        scrolling: { mode: 'virtual', preloadEnabled: true, renderAsync: false }
                    });
                }
                instance.pageSize(pageSize);
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    /** @type {?} */
                    const pageCount = instance.pageCount();
                    this.pageSize = pageSize.toString();
                    this.pageNumbers = [];
                    for (let i = 0; i < pageCount; i++) {
                        this.pageNumbers.push(i + 1);
                    }
                    this.registerDataSourceChange();
                    if (!this.selectedPage || this.pageNumbers.indexOf(this.selectedPage) === -1) {
                        this.onPageChange({ value: this.pageNumbers[0] });
                    }
                    else {
                        this.dataGrid.instance.pageIndex(this.selectedPage - 1);
                        setTimeout(this.updatePagingInfo.bind(this), 250);
                    }
                }), 10);
            }
            else if (e.value === 'All') {
                this.selectedPage = null;
                this.pageNumbers = [];
                this.pageSize = e.value;
                if (this.isAllPageSize) {
                    this.registerDataSourceChange();
                    this.updatePagingInfo();
                }
                else {
                    this.isAllPageSize = true;
                    instance.option({
                        dataSource: this.dataSource,
                        paging: { enabled: true, pageSize: this.dataSource.length, pageIndex: 0 },
                        scrolling: {
                            mode: 'virtual',
                            preloadEnabled: true,
                            renderAsync: false
                        }
                    });
                    setTimeout((/**
                     * @return {?}
                     */
                    () => {
                        this.registerDataSourceChange();
                        this.updatePagingInfo();
                    }), 250);
                }
            }
        }
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onPageChange(e) {
        this.selectedPage = e.value || e.previousValue;
        this.dataGrid.instance.pageIndex(this.selectedPage - 1);
        setTimeout(this.updatePagingInfo.bind(this), 250);
    }
    /**
     * @private
     * @return {?}
     */
    updatePagingInfo() {
        /** @type {?} */
        const instance = this.dataGrid.instance;
        /** @type {?} */
        const totalCount = Math.max(0, this.totalCount);
        if (this.isAllPageSize) {
            this.pageInfoText = `${totalCount} items`;
        }
        else {
            this.noOfPages = instance.pageCount();
            this.pageNumber = instance.pageIndex();
            this.isFirstPage = this.selectedPage === this.pageNumbers[0];
            this.isLastPage = this.selectedPage === this.pageNumbers[this.pageNumbers.length - 1];
            this.pageInfoText = `Page ${this.pageNumber + 1} of ${this.noOfPages} (${totalCount} items)`;
        }
    }
    /**
     * @private
     * @return {?}
     */
    registerDataSourceChange() {
        if (!!this.dataGrid && !!this.dataGrid.instance && this.dataGrid.instance.getDataSource) {
            /** @type {?} */
            const dataSource = this.dataGrid.instance.getDataSource();
            if (!!dataSource) {
                this.totalCount = dataSource.totalCount();
                if (this.isAllPageSize) {
                    this.totalCount = dataSource.items().length;
                }
                dataSource.off('loadingChanged', this.onDataSourceChanged.bind(this));
                dataSource.on('loadingChanged', this.onDataSourceChanged.bind(this));
            }
        }
    }
    /**
     * @private
     * @return {?}
     */
    onDataSourceChanged() {
        clearTimeout(this._dsEventTimer);
        this._dsEventTimer = setTimeout((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const dataSource = this.dataGrid.instance.getDataSource();
            if (!!dataSource) {
                /** @type {?} */
                let currentCount = dataSource.totalCount();
                if (this.isAllPageSize) {
                    currentCount = dataSource.items().length;
                }
                if (this.totalCount !== currentCount) {
                    this.totalCount = currentCount;
                    /** @type {?} */
                    const pageSize = this.pageSize;
                    this.pageSize = null;
                    this.onPageSizeChange({ value: pageSize });
                }
            }
            clearTimeout(this._dsEventTimer);
        }), 1000);
    }
}
DataGridPagerComponent.decorators = [
    { type: Component, args: [{
                selector: 'cc-data-grid-pager',
                template: "<dx-box width=\"100%\" direction=\"row\" *ngIf=\"showToolbar\" class=\"paging-toolbar-container\">\n    <dxi-item [ratio]=\"1\" *ngIf=\"pagingConfig?.visible\">\n        <dx-toolbar width=\"100%\" class=\"paging-toolbar\">\n            <dxi-item location=\"before\" *ngIf=\"pagingConfig?.showPageSizeSelector\">\n                <div *dxTemplate class=\"cc-page-size-selector\">\n                    <div class=\"dx-field-label\">Rows / Page:</div>\n                </div>\n            </dxi-item>\n            <dxi-item location=\"before\" *ngIf=\"pagingConfig?.showPageSizeSelector\">\n                <div *dxTemplate class=\"cc-page-size-selector\">\n                    <div class=\"dx-field-value\">\n                        <dx-select-box\n                            [value]=\"pageSize\"\n                            [items]=\"pagingConfig?.allowedPageSizes\"\n                            (onValueChanged)=\"onPageSizeChange($event)\"\n                        ></dx-select-box>\n                    </div>\n                </div>\n            </dxi-item>\n            <dxi-item location=\"before\" *ngIf=\"pagingConfig?.showNavigationButtons && !isAllPageSize\">\n                <div *dxTemplate class=\"cc-page-navigators\">\n                    <dx-toolbar width=\"100%\">\n                        <dxi-item\n                            [visible]=\"!isSmallScreen\"\n                            location=\"before\"\n                            widget=\"dxButton\"\n                            [options]=\"{\n                                stylingMode: 'text',\n                                icon: 'fas fa-fast-backward',\n                                hint: 'First Page',\n                                disabled: isFirstPage,\n                                onClick: onFirstPage\n                            }\"\n                        ></dxi-item>\n                        <dxi-item\n                            location=\"before\"\n                            widget=\"dxButton\"\n                            [options]=\"{\n                                stylingMode: 'text',\n                                icon: 'fas fa-step-backward',\n                                hint: 'Previous Page',\n                                disabled: isFirstPage || pageNumber === 0,\n                                onClick: onPreviousPage\n                            }\"\n                        ></dxi-item>\n                        <dxi-item location=\"before\">\n                            <div *dxTemplate>\n                                <dx-select-box\n                                    [width]=\"64\"\n                                    [items]=\"pageNumbers\"\n                                    [value]=\"selectedPage\"\n                                    [searchEnabled]=\"true\"\n                                    (onValueChanged)=\"onPageChange($event)\"\n                                ></dx-select-box>\n                            </div>\n                        </dxi-item>\n                        <dxi-item\n                            location=\"before\"\n                            widget=\"dxButton\"\n                            [options]=\"{\n                                stylingMode: 'text',\n                                icon: 'fas fa-step-forward',\n                                hint: 'Next Page',\n                                disabled: isLastPage || pageNumber === noOfPages,\n                                onClick: onNextPage\n                            }\"\n                        ></dxi-item>\n                        <dxi-item\n                            [visible]=\"!isSmallScreen\"\n                            location=\"before\"\n                            widget=\"dxButton\"\n                            [options]=\"{\n                                stylingMode: 'text',\n                                icon: 'fas fa-fast-forward',\n                                hint: 'Last Page',\n                                disabled: isLastPage,\n                                onClick: onLastPage\n                            }\"\n                        ></dxi-item>\n                    </dx-toolbar>\n                </div>\n            </dxi-item>\n            <dxi-item location=\"before\" *ngIf=\"pagingConfig?.showInfo\" [visible]=\"!isSmallScreen\">\n                <div *dxTemplate class=\"cc-page-info\">\n                    {{ pageInfoText }}\n                </div>\n            </dxi-item>\n        </dx-toolbar>\n    </dxi-item>\n    <dxi-item baseSize=\"auto\" *ngIf=\"!isSmallScreen\">\n        <dx-toolbar #pagingToolbar width=\"100%\"></dx-toolbar>\n    </dxi-item>\n</dx-box>\n",
                styles: [":host{width:100%;height:100%}.paging-toolbar-container{padding:0 1.25rem}.paging-toolbar-container .paging-toolbar{width:100%}.paging-toolbar-container .paging-toolbar .cc-page-size-selector .dx-field-label,.paging-toolbar-container .paging-toolbar .cc-page-size-selector .dx-field-value{width:unset}.paging-toolbar-container .paging-toolbar .cc-page-size-selector .dx-field-value{float:left}.paging-toolbar-container .paging-toolbar .cc-page-size-selector .dx-selectbox{max-width:54px}.paging-toolbar-container .paging-toolbar .cc-page-navigators{min-width:190px}.paging-toolbar-container .cc-page-info{min-width:150px}"]
            }] }
];
/** @nocollapse */
DataGridPagerComponent.ctorParameters = () => [
    { type: CCScreenService }
];
DataGridPagerComponent.propDecorators = {
    pagingToolbar: [{ type: ViewChild, args: ['pagingToolbar', { static: false },] }],
    hasGrouping: [{ type: Input }],
    dataSource: [{ type: Input }],
    dataGrid: [{ type: Input }],
    pagingConfig: [{ type: Input }],
    toolbarItems: [{ type: Input }]
};
if (false) {
    /** @type {?} */
    DataGridPagerComponent.prototype.pagingToolbar;
    /** @type {?} */
    DataGridPagerComponent.prototype.hasGrouping;
    /** @type {?} */
    DataGridPagerComponent.prototype.dataSource;
    /** @type {?} */
    DataGridPagerComponent.prototype.dataGrid;
    /** @type {?} */
    DataGridPagerComponent.prototype.pagingConfig;
    /** @type {?} */
    DataGridPagerComponent.prototype.toolbarItems;
    /** @type {?} */
    DataGridPagerComponent.prototype.showToolbar;
    /** @type {?} */
    DataGridPagerComponent.prototype.isFirstPage;
    /** @type {?} */
    DataGridPagerComponent.prototype.isLastPage;
    /** @type {?} */
    DataGridPagerComponent.prototype.pageSize;
    /** @type {?} */
    DataGridPagerComponent.prototype.pageNumber;
    /** @type {?} */
    DataGridPagerComponent.prototype.noOfPages;
    /** @type {?} */
    DataGridPagerComponent.prototype.pageNumbers;
    /** @type {?} */
    DataGridPagerComponent.prototype.selectedPage;
    /** @type {?} */
    DataGridPagerComponent.prototype.isAllPageSize;
    /** @type {?} */
    DataGridPagerComponent.prototype.pageInfoText;
    /** @type {?} */
    DataGridPagerComponent.prototype.isSmallScreen;
    /** @type {?} */
    DataGridPagerComponent.prototype.totalCount;
    /**
     * @type {?}
     * @private
     */
    DataGridPagerComponent.prototype._dsEventTimer;
    /** @type {?} */
    DataGridPagerComponent.prototype.onFirstPage;
    /** @type {?} */
    DataGridPagerComponent.prototype.onPreviousPage;
    /** @type {?} */
    DataGridPagerComponent.prototype.onNextPage;
    /** @type {?} */
    DataGridPagerComponent.prototype.onLastPage;
    /**
     * @type {?}
     * @private
     */
    DataGridPagerComponent.prototype.screenService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCLocalStorageParameterDto {
    constructor() {
        this.clearCache = false;
    }
    /**
     * @return {?}
     */
    getQueryString() {
        /** @type {?} */
        const tokens = [`userId=${this.userId}`, `portalType=${this.portalType}`];
        if (!!this.key && this.key.length > 0) {
            tokens.push(`key=${this.key}`);
        }
        if (!!this.category && this.category.length > 0) {
            tokens.push(`category=${this.category}`);
        }
        tokens.push(`clearCache=${this.clearCache}`);
        return `?${tokens.join('&')}`;
    }
}
if (false) {
    /** @type {?} */
    CCLocalStorageParameterDto.prototype.userId;
    /** @type {?} */
    CCLocalStorageParameterDto.prototype.portalType;
    /** @type {?} */
    CCLocalStorageParameterDto.prototype.key;
    /** @type {?} */
    CCLocalStorageParameterDto.prototype.category;
    /** @type {?} */
    CCLocalStorageParameterDto.prototype.clearCache;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCLocalStorageRawDto {
}
if (false) {
    /** @type {?} */
    CCLocalStorageRawDto.prototype.key;
    /** @type {?} */
    CCLocalStorageRawDto.prototype.userId;
    /** @type {?} */
    CCLocalStorageRawDto.prototype.portalType;
    /** @type {?} */
    CCLocalStorageRawDto.prototype.value;
    /** @type {?} */
    CCLocalStorageRawDto.prototype.category;
    /** @type {?} */
    CCLocalStorageRawDto.prototype.lastUpdatedDate;
    /** @type {?} */
    CCLocalStorageRawDto.prototype.lastUpdatedBy;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCResultStatus {
}
if (false) {
    /** @type {?} */
    CCResultStatus.prototype.isSuccess;
    /** @type {?} */
    CCResultStatus.prototype.errorMessage;
}
class CCLocalStorageService {
    /**
     * @param {?} key
     * @param {?=} category
     * @return {?}
     */
    getItem(key, category) {
        /** @type {?} */
        const storageKey = this.getStorageKey(key, category);
        return localStorage.getItem(storageKey);
    }
    /**
     * @param {?} key
     * @param {?} value
     * @param {?=} category
     * @return {?}
     */
    setItem(key, value, category) {
        this.saveSetting(key, value, category).subscribe();
        /** @type {?} */
        const storageKey = this.getStorageKey(key, category);
        localStorage.setItem(storageKey, value);
    }
    /**
     * @param {?} key
     * @param {?=} category
     * @return {?}
     */
    removeItem(key, category) {
        this.removeSetting(key, category).subscribe();
        /** @type {?} */
        const storageKey = this.getStorageKey(key, category);
        localStorage.removeItem(storageKey);
    }
    // This will clear all the user settings from both client and server.
    /**
     * @param {?=} category
     * @param {?=} clearOnServer
     * @return {?}
     */
    clear(category, clearOnServer = false) {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            /** @type {?} */
            const prefix = this.getStorageKeyPrefix(category);
            /** @type {?} */
            const storageKeys = [];
            for (let i = 0; i < localStorage.length; i++) {
                /** @type {?} */
                const storageKey = localStorage.key(i);
                if (storageKey.startsWith(prefix)) {
                    storageKeys.push(storageKey);
                }
            }
            storageKeys.forEach((/**
             * @param {?} storageKey
             * @return {?}
             */
            (storageKey) => {
                if (clearOnServer === true) {
                    /** @type {?} */
                    const key = storageKey.replace(`${prefix}_`, ``).trim();
                    this.removeItem(key, category);
                }
                else {
                    localStorage.removeItem(storageKey);
                }
            }));
            observer.next(true);
            observer.complete();
        }));
    }
    /**
     * @param {?=} key
     * @param {?=} category
     * @return {?}
     */
    loadItems(key, category) {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            if (!!this.userId && !!this.portalType && !!this.getItemApi) {
                /** @type {?} */
                const param = new CCLocalStorageParameterDto();
                param.userId = this.userId;
                param.portalType = this.portalType;
                param.key = (key || '').toUpperCase();
                param.category = category;
                param.clearCache = true;
                this.getItemApi(param).subscribe((/**
                 * @param {?} results
                 * @return {?}
                 */
                (results) => {
                    results.forEach((/**
                     * @param {?} result
                     * @return {?}
                     */
                    (result) => {
                        /** @type {?} */
                        const storageKey = this.getStorageKey(result.key, result.category);
                        localStorage.setItem(storageKey, result.value);
                    }));
                    observer.next(results);
                    observer.complete();
                }));
            }
            else {
                observer.next(null);
                observer.complete();
            }
        }));
    }
    /**
     * @private
     * @param {?} key
     * @param {?=} category
     * @return {?}
     */
    getStorageKey(key, category) {
        /** @type {?} */
        const prefix = this.getStorageKeyPrefix(category);
        return `${prefix}_${key}`.toUpperCase();
    }
    /**
     * @private
     * @param {?=} category
     * @return {?}
     */
    getStorageKeyPrefix(category) {
        /** @type {?} */
        const tokens = [];
        if (!!this.portalType) {
            tokens.push(`${this.portalType}`);
        }
        if (!!this.userId) {
            tokens.push(`${this.userId.replace(/ /gi, '_')}`);
        }
        if (!!category) {
            tokens.push(`${category}`);
        }
        return `${tokens.join('_').toUpperCase()}`;
    }
    /**
     * @param {?} key
     * @param {?} value
     * @param {?=} category
     * @return {?}
     */
    saveSetting(key, value, category) {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            if (!!this.userId && !!this.portalType) {
                /** @type {?} */
                const isUpdated = value !== this.getItem(key, category);
                if (!!this.setItemApi && isUpdated) {
                    /** @type {?} */
                    const payload = new CCLocalStorageRawDto();
                    payload.userId = this.userId;
                    payload.portalType = this.portalType;
                    payload.key = key.toUpperCase();
                    payload.value = value;
                    payload.category = category;
                    this.setItemApi(payload).subscribe((/**
                     * @param {?} result
                     * @return {?}
                     */
                    (result) => {
                        observer.next(result.isSuccess);
                        observer.complete();
                    }));
                }
                else {
                    observer.next(false);
                    observer.complete();
                }
            }
            else {
                observer.next(false);
                observer.complete();
            }
        }));
    }
    /**
     * @param {?} key
     * @param {?=} category
     * @return {?}
     */
    removeSetting(key, category) {
        return new Observable((/**
         * @param {?} observer
         * @return {?}
         */
        (observer) => {
            if (!!this.userId && !!this.portalType && !!this.removeItemApi) {
                /** @type {?} */
                const param = new CCLocalStorageParameterDto();
                param.userId = this.userId;
                param.portalType = this.portalType;
                param.key = key.toUpperCase();
                param.category = category;
                param.clearCache = true;
                this.removeItemApi(param).subscribe((/**
                 * @param {?} result
                 * @return {?}
                 */
                (result) => {
                    observer.next(result.isSuccess);
                    observer.complete();
                }));
            }
            else {
                observer.next(false);
                observer.complete();
            }
        }));
    }
}
CCLocalStorageService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ CCLocalStorageService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CCLocalStorageService_Factory() { return new CCLocalStorageService(); }, token: CCLocalStorageService, providedIn: "root" });
if (false) {
    /** @type {?} */
    CCLocalStorageService.prototype.getItemApi;
    /** @type {?} */
    CCLocalStorageService.prototype.setItemApi;
    /** @type {?} */
    CCLocalStorageService.prototype.removeItemApi;
    /** @type {?} */
    CCLocalStorageService.prototype.userId;
    /** @type {?} */
    CCLocalStorageService.prototype.portalType;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCDataGridFeatures {
    constructor() {
        this.stylingMode = 'toolbar';
        this.placement = 'top';
        this.allowExpandCollapse = true;
        this.allowColumnsSelector = true;
        this.allowSaveLayout = true;
        this.allowResetLayout = true;
        this.allowExcelExport = true;
        this.allowCSVExport = true;
        this.allowRowTracking = true;
        this.allowPaging = true;
        this.allowSearch = true;
        this.allowFullscreen = true;
        this.allowModeSwitch = true;
        this.allowPlacementSwitch = true;
        this.allowHeaderFilters = true;
        this.allowRowFilters = true;
        this.allowGrouping = true;
        this.showLoadPanel = false;
        this.allowColumnReordering = true;
        this.allowColumnResizing = true;
        this.allowColumnHiding = true;
        this.columnAutoWidth = true;
        this.showBorders = true;
        this.showRowLines = true;
        this.rowAlternationEnabled = false;
        this.wordWrapEnabled = true;
        this.columnResizingMode = 'widget';
        this.noDataText = 'No data to display';
        this.allowWildcardFilter = true;
        this.columnSortingMode = 'multiple';
    }
}
if (false) {
    /** @type {?} */
    CCDataGridFeatures.prototype.stylingMode;
    /** @type {?} */
    CCDataGridFeatures.prototype.placement;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowExpandCollapse;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowColumnsSelector;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowSaveLayout;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowResetLayout;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowExcelExport;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowCSVExport;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowRowTracking;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowPaging;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowSearch;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowFullscreen;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowModeSwitch;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowPlacementSwitch;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowHeaderFilters;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowRowFilters;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowGrouping;
    /** @type {?} */
    CCDataGridFeatures.prototype.showLoadPanel;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowColumnReordering;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowColumnResizing;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowColumnHiding;
    /** @type {?} */
    CCDataGridFeatures.prototype.columnAutoWidth;
    /** @type {?} */
    CCDataGridFeatures.prototype.showBorders;
    /** @type {?} */
    CCDataGridFeatures.prototype.showRowLines;
    /** @type {?} */
    CCDataGridFeatures.prototype.rowAlternationEnabled;
    /** @type {?} */
    CCDataGridFeatures.prototype.wordWrapEnabled;
    /** @type {?} */
    CCDataGridFeatures.prototype.columnResizingMode;
    /** @type {?} */
    CCDataGridFeatures.prototype.noDataText;
    /** @type {?} */
    CCDataGridFeatures.prototype.allowWildcardFilter;
    /** @type {?} */
    CCDataGridFeatures.prototype.columnSortingMode;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCDataGridStateConfig {
    constructor() {
        this.storeGroupings = false;
        this.storeFilters = false;
        this.storeSortings = false;
    }
}
if (false) {
    /** @type {?} */
    CCDataGridStateConfig.prototype.storageKey;
    /** @type {?} */
    CCDataGridStateConfig.prototype.storeGroupings;
    /** @type {?} */
    CCDataGridStateConfig.prototype.storeFilters;
    /** @type {?} */
    CCDataGridStateConfig.prototype.storeSortings;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {string} */
const CCLocalStorageCategory = {
    DXG: 'DXG',
    DXGT: 'DXGT',
    DASH: 'DASH',
    CHART: 'CHART',
    PREF: 'PREF',
    FAV: 'FAV',
    EMAIL: 'EMAIL',
    WFE: 'WFE',
    LITE: 'LITE',
    FLTR: 'FILTER',
    MASSCOMM: 'MASSCOMM_TMPL',
    CCBWQ: 'CCBWQ',
    MYTXT: 'MYTXT',
    HELPCONF: 'HELPCONF',
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DataGridFeaturesComponent {
    /**
     * @param {?} screenService
     * @param {?} localStorageService
     */
    constructor(screenService, localStorageService) {
        this.screenService = screenService;
        this.localStorageService = localStorageService;
        this.gridFeatures = new CCDataGridFeatures();
        this.stateConfig = new CCDataGridStateConfig();
        this.pagingConfig = new CCDataGridPagingConfig();
        this.useRatio = true;
        this.isIconsVisible = false;
        this.isSearchVisible = false;
        this.defaultPageSize = '50';
        this.isPageScroll = false;
        this.isExpanded = true;
        this.isInFullScreen = false;
        this.hasGrouping = false;
        this.hasStateSave = false;
        this.groupedColumns = [];
        this.stylingMode = 'toolbar';
        this.isInitComplete = false;
        this.viewSubscriptions = [];
        this.viewTimerIds = [];
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onEscapeKeyDown(e) {
        if (this.isInFullScreen) {
            this.onAction('ExitFullscreen');
        }
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.gridFeatures = plainToClass(CCDataGridFeatures, Object.assign({}, classToPlain(new CCDataGridFeatures()), classToPlain(this.gridFeatures)));
        this.stateConfig = plainToClass(CCDataGridStateConfig, Object.assign({}, classToPlain(new CCDataGridStateConfig()), classToPlain(this.stateConfig)));
        this.pagingConfig = plainToClass(CCDataGridPagingConfig, Object.assign({}, classToPlain(new CCDataGridPagingConfig()), classToPlain(this.pagingConfig)));
        this.offsetHeight = 0;
        this.defaultPageSize = this.pagingConfig.defaultPageSize;
        if (this.gridFeatures.allowPaging && this.pagingConfig.visible) {
            this.offsetHeight = 36;
        }
        else {
            this.pagingConfig.visible = false;
        }
        this.isSmallScreen = this.screenService.isSmallScreen();
        this.screenChangeSubscription = this.screenService.changed.subscribe((/**
         * @return {?}
         */
        () => {
            this.isSmallScreen = this.screenService.isSmallScreen();
            this.onScreenSizeChange();
        }));
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (!!changes.dataSource && !!changes.dataSource.currentValue) {
            if (!!this.grid && !!this.grid.instance && !!this.grid.instance.element().parentElement) {
                this.grid.instance.refresh();
            }
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.isInitComplete = false;
        /** @type {?} */
        const instance = this.grid.instance;
        this.hasStateSave = !!this.stateConfig.storageKey && !!this.stateConfig.storageKey.length;
        instance.beginUpdate();
        this.loadStyleMode();
        this.reconfigure();
        instance.on('toolbarPreparing', this.onToolbarPreparing.bind(this));
        instance.on('exporting', this.onExporting.bind(this));
        instance.on('optionChanged', this.onOptionChanged.bind(this));
        if (this.hasStateSave) {
            /** @type {?} */
            const options = {
                stateStoring: {
                    type: 'custom',
                    enabled: this.hasStateSave,
                    customLoad: this.getGridState.bind(this),
                    customSave: this.saveGridState.bind(this),
                    savingTimeout: 1000
                }
            };
            instance.option(options);
        }
        this.viewTimerIds.push(setTimeout((/**
         * @return {?}
         */
        () => {
            instance.endUpdate();
            this.isInitComplete = true;
        }), 1000));
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        clearTimeout(this.repaintTimerId);
        if (!!this.screenChangeSubscription) {
            this.screenChangeSubscription.unsubscribe();
        }
        this.viewSubscriptions.forEach((/**
         * @param {?} subscription
         * @return {?}
         */
        (subscription) => subscription.unsubscribe()));
        this.viewTimerIds.forEach((/**
         * @param {?} timerId
         * @return {?}
         */
        (timerId) => clearTimeout(timerId)));
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onToolbarAction(e) {
        this.onAction(e);
    }
    /**
     * @return {?}
     */
    repaint() {
        clearTimeout(this.repaintTimerId);
        this.repaintTimerId = setTimeout((/**
         * @return {?}
         */
        () => {
            if (!!this.grid && !!this.grid.instance && !!this.grid.instance.element().parentElement) {
                try {
                    this.grid.instance.repaint();
                    this.pager.onGridRowsRepaint();
                }
                catch (_a) {
                    alert(`An internal error occurred with the grid. Please reload / refresh your browser window to fix this error`, 'Grid Error');
                }
            }
        }), 1000);
    }
    /**
     * @param {?} e
     * @return {?}
     */
    resized(e) {
        this.isSmallScreen = e.width < 786;
        this.onScreenSizeChange();
    }
    /**
     * @param {?=} gridFeatures
     * @return {?}
     */
    reconfigure(gridFeatures) {
        /** @type {?} */
        const instance = this.grid.instance;
        if (!!gridFeatures) {
            this.gridFeatures = plainToClass(CCDataGridFeatures, Object.assign({}, classToPlain(this.gridFeatures), classToPlain(gridFeatures)));
            instance.beginUpdate();
        }
        /** @type {?} */
        const columns = (/** @type {?} */ (instance.option('columns')));
        columns.forEach((/**
         * @param {?} col
         * @return {?}
         */
        (col) => {
            if (!col.dataType) {
                col.allowFiltering = false;
                col.allowHeaderFiltering = false;
            }
            else if (col.dataType === 'boolean') {
                col.allowFiltering = true;
                col.allowHeaderFiltering = false;
                col.trueText = 'Yes';
                col.falseText = 'No';
            }
            else if (col.dataType === 'string' && this.gridFeatures.allowWildcardFilter) {
                col.calculateFilterExpression = this.wildcardFilterExpression;
            }
            else if (col.dataType === 'number') {
                col.filterOperations = ['contains', '=', '<>', '<', '>', '<=', '>=', 'between'];
            }
            else if (col.dataType === 'date' || col.dataType === 'datetime') {
                col.filterOperations = ['contains', '=', '<>', '<', '>', '<=', '>=', 'between'];
            }
        }));
        /** @type {?} */
        const options = {
            allowColumnReordering: this.gridFeatures.allowColumnReordering,
            allowColumnResizing: this.gridFeatures.allowColumnResizing,
            columnHidingEnabled: this.gridFeatures.allowColumnHiding,
            columnChooser: { enabled: this.gridFeatures.allowColumnHiding, sortOrder: 'asc' },
            columnAutoWidth: this.gridFeatures.columnAutoWidth,
            showBorders: this.gridFeatures.showBorders,
            showRowLines: this.gridFeatures.showRowLines,
            rowAlternationEnabled: this.gridFeatures.rowAlternationEnabled,
            wordWrapEnabled: this.gridFeatures.wordWrapEnabled,
            columnResizingMode: this.isSmallScreen ? 'nextColumn' : this.gridFeatures.columnResizingMode,
            noDataText: this.gridFeatures.noDataText,
            filterPanel: { visible: this.gridFeatures.allowHeaderFilters },
            filterRow: { visible: this.gridFeatures.allowRowFilters },
            headerFilter: { visible: this.gridFeatures.allowHeaderFilters, allowSearch: true },
            groupPanel: { visible: this.gridFeatures.allowGrouping, emptyPanelText: 'Drag a column here to group' },
            loadPanel: { enabled: this.gridFeatures.showLoadPanel },
            activeStateEnabled: true,
            focusStateEnabled: this.gridFeatures.allowRowTracking,
            hoverStateEnabled: this.gridFeatures.allowRowTracking,
            sorting: { mode: this.gridFeatures.columnSortingMode },
            paging: {
                enabled: this.gridFeatures.allowPaging,
                pageSize: this.pagingConfig.defaultPageSize,
                pageIndex: 0
            },
            pager: {
                allowedPageSizes: this.pagingConfig.allowedPageSizes,
                visible: false
            },
            columns
        };
        instance.option(options);
        this.isIconsVisible = this.stylingMode !== 'toolbar-collapsed';
        this.isSearchVisible = (instance.option('searchPanel') || { visible: false }).visible;
        this.isExpanded = (instance.option('grouping') || { autoExpandAll: true }).autoExpandAll;
        if (!!gridFeatures) {
            this.onScreenSizeChange();
            instance.endUpdate();
        }
    }
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    onOptionChanged(e) {
        if (e.name === 'columns' &&
            (e.fullName.indexOf('visible') !== -1 || e.fullName.indexOf('.groupIndex') !== -1)) {
            this.repaint();
        }
    }
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    onToolbarPreparing(e) {
        if (this.gridFeatures.allowGrouping) {
            /** @type {?} */
            let columns = (/** @type {?} */ (e.component.option('columns')));
            /** @type {?} */
            let groups = columns.filter((/**
             * @param {?} col
             * @return {?}
             */
            (col) => String(col.groupIndex) !== 'null' && typeof col.groupIndex !== 'undefined'));
            if (groups.length === 0) {
                columns = e.component.getVisibleColumns();
                groups = columns.filter((/**
                 * @param {?} col
                 * @return {?}
                 */
                (col) => col.type === 'groupExpand'));
            }
            this.hasGrouping = groups.length > 0;
        }
        /** @type {?} */
        const toolbarItems = [];
        /** @type {?} */
        const defaultItems = e.toolbarOptions.items.filter((/**
         * @param {?} r
         * @return {?}
         */
        (r) => r.name !== 'columnChooserButton'));
        if (this.stylingMode === 'menu') {
            this.addMenus(toolbarItems);
        }
        else if (this.stylingMode !== 'hidden') {
            this.addButtons(toolbarItems);
        }
        if (toolbarItems.length > 0) {
            if (this.gridFeatures.allowPaging && this.pagingConfig.visible) {
                if (this.gridFeatures.placement === 'bottom') {
                    // Defer update to avoid change detection error
                    setTimeout((/**
                     * @return {?}
                     */
                    () => {
                        this.pagingConfig.toolbarItems = toolbarItems;
                    }), 250);
                }
                else if (this.gridFeatures.placement === 'top') {
                    this.pagingConfig.toolbarItems = [];
                    e.toolbarOptions.items = defaultItems.concat(toolbarItems);
                }
            }
            else {
                this.pagingConfig.toolbarItems = [];
                e.toolbarOptions.items = defaultItems.concat(toolbarItems);
            }
        }
    }
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    onExporting(e) {
        /** @type {?} */
        const workbook = new Workbook();
        /** @type {?} */
        const worksheet = workbook.addWorksheet('Main Sheet');
        exportDataGrid({
            component: e.component,
            worksheet,
            customizeCell: (/**
             * @param {?} __0
             * @return {?}
             */
            ({ gridCell, excelCell }) => {
                if (gridCell.rowType === 'data' && gridCell.column.dataType === 'boolean') {
                    excelCell.value = '';
                    if (gridCell.value === true) {
                        excelCell.value = 'Yes';
                    }
                    else if (gridCell.value === false) {
                        excelCell.value = 'No';
                    }
                }
            })
        }).then((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            let writer = workbook.xlsx;
            /** @type {?} */
            let options = {};
            /** @type {?} */
            let fileName = 'ExportedData.xlsx';
            if (this.exportMode === 'CSV') {
                writer = workbook.csv;
                fileName = 'ExportedData.csv';
                options = { delimiter: ',' };
            }
            writer.writeBuffer(options).then((/**
             * @param {?} buffer
             * @return {?}
             */
            (buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName);
            }));
        }));
        e.cancel = true;
    }
    /**
     * @private
     * @param {?} icon
     * @param {?} hint
     * @param {?=} type
     * @param {?=} stylingMode
     * @param {?=} template
     * @return {?}
     */
    getButtonOptions(icon, hint, type = 'normal', stylingMode = 'contained', template = 'content') {
        /** @type {?} */
        const action = hint.replace(/ /gi, '');
        return {
            stylingMode,
            type,
            icon,
            hint,
            action,
            template,
            onClick: (/**
             * @return {?}
             */
            () => this.onMenuButtonClick({ action }))
        };
    }
    /**
     * @private
     * @param {?} instance
     * @return {?}
     */
    exportGridData(instance) {
        /** @type {?} */
        const columns = instance.getVisibleColumns();
        if (this.exportMode === 'CSV') {
            this.groupedColumns = [];
            columns.forEach((/**
             * @param {?} col
             * @return {?}
             */
            (col) => {
                if (col.hasOwnProperty('groupIndex') && (col.groupIndex !== undefined || col.groupIndex !== null)) {
                    this.groupedColumns.push({
                        dataField: col.dataField,
                        groupIndex: col.groupIndex
                    });
                }
            }));
            this.grid.instance.clearGrouping();
        }
        this.viewTimerIds.push(setTimeout((/**
         * @return {?}
         */
        () => {
            instance.exportToExcel(false);
            this.viewTimerIds.push(setTimeout((/**
             * @return {?}
             */
            () => {
                if (this.exportMode === 'CSV') {
                    this.groupedColumns.forEach((/**
                     * @param {?} gcol
                     * @return {?}
                     */
                    (gcol) => {
                        /** @type {?} */
                        const grouped = columns.find((/**
                         * @param {?} col
                         * @return {?}
                         */
                        (col) => col.dataField === gcol.dataField));
                        if (!!grouped) {
                            this.grid.instance.columnOption(grouped.dataField, 'groupIndex', gcol.groupIndex);
                        }
                    }));
                }
            }), 250));
        }), 250));
    }
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    onMenuButtonClick(e) {
        this.onAction(e.action);
    }
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    onMenuItemClick(e) {
        this.onAction(e.itemData.action);
    }
    /**
     * @private
     * @param {?} toolbarItems
     * @return {?}
     */
    addButtons(toolbarItems) {
        toolbarItems.push({
            widget: 'dxButton',
            location: 'after',
            visible: this.gridFeatures.allowSearch && !this.isSearchVisible && this.isIconsVisible,
            options: this.getButtonOptions('cc-icon fas fa-search', 'Show Search')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.gridFeatures.allowSearch && this.isSearchVisible && this.isIconsVisible,
            options: this.getButtonOptions('cc-icon dx-theme-accent-as-text-color fas fa-search', 'Hide Search')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.gridFeatures.allowExpandCollapse &&
                this.hasGrouping &&
                !this.isExpanded &&
                this.isIconsVisible,
            options: this.getButtonOptions('cc-icon far fa-plus-square', 'Expand All')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.gridFeatures.allowExpandCollapse && this.hasGrouping && this.isExpanded && this.isIconsVisible,
            options: this.getButtonOptions('cc-icon far fa-minus-square', 'Collapse All')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.gridFeatures.allowColumnsSelector && this.isIconsVisible,
            options: this.getButtonOptions('cc-icon dx-icon-columnchooser', 'Column Chooser', 'normal', 'contained', (/**
             * @return {?}
             */
            () => {
                /** @type {?} */
                const hasHidden = this.hasHiddenColumn();
                if (hasHidden) {
                    return `<span class="cc-stack fa-stack">
                              <i class="dx-icon dx-icon-columnchooser fa-stack-2x"></i>
                              <i class="fas fa-star fa-stack-1x dx-theme-accent-as-text-color"></i>
                            </span>`;
                }
                else {
                    return `<span class="cc-stack fa-stack">
                              <i class="dx-icon dx-icon-columnchooser fa-stack-2x"></i>
                            </span>`;
                }
            }))
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.hasStateSave &&
                this.gridFeatures.allowSaveLayout &&
                this.isIconsVisible &&
                !this.isSmallScreen,
            options: this.getButtonOptions('cc-icon fas fa-save', 'Save Layout')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.gridFeatures.allowResetLayout && this.isIconsVisible && !this.isSmallScreen,
            options: this.getButtonOptions('cc-icon fas fa-ban fa-flip-horizontal', 'Reset Layout')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.gridFeatures.allowExcelExport && this.isIconsVisible,
            options: this.getButtonOptions('cc-icon fas fa-file-excel', 'Export To Excel')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.gridFeatures.allowCSVExport && this.isIconsVisible,
            options: this.getButtonOptions('cc-icon fas fa-file-csv', 'Export To CSV')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: !this.gridFeatures.allowRowTracking && this.isIconsVisible,
            options: this.getButtonOptions('cc-icon far fa-hand-pointer', 'Enable Row Hot Track')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.gridFeatures.allowRowTracking && this.isIconsVisible,
            options: this.getButtonOptions('cc-icon dx-theme-accent-as-text-color far fa-hand-pointer', 'Disable Row Hot Track')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.isInFullScreen && this.gridFeatures.allowFullscreen && this.isIconsVisible,
            options: this.getButtonOptions('cc-icon fas fa-external-link-alt fa-rotate-180', 'Normal View')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: !this.isInFullScreen && this.gridFeatures.allowFullscreen && this.isIconsVisible,
            options: this.getButtonOptions('cc-icon fas fa-external-link-alt', 'Fullscreen View')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.gridFeatures.placement === 'top' &&
                this.gridFeatures.allowPlacementSwitch &&
                this.isIconsVisible &&
                !this.isSmallScreen,
            options: this.getButtonOptions('cc-icon fas fa-long-arrow-alt-down', 'Move Features To Bottom')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.gridFeatures.placement === 'bottom' &&
                this.gridFeatures.allowPlacementSwitch &&
                this.isIconsVisible &&
                !this.isSmallScreen,
            options: this.getButtonOptions('cc-icon fas fa-long-arrow-alt-up', 'Move Features To Top')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.stylingMode !== 'menu' &&
                this.gridFeatures.allowModeSwitch &&
                this.isIconsVisible &&
                !this.isSmallScreen,
            options: this.getButtonOptions('cc-icon far fa-list-alt', 'Switch To Menu Mode')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.isIconsVisible,
            options: this.getButtonOptions('cc-icon fas fa-angle-double-right', 'Hide Configuration')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: !this.isIconsVisible,
            options: this.getButtonOptions('cc-icon fas fa-angle-double-left', 'Show Configuration')
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.isInFullScreen,
            options: this.getButtonOptions('cc-icon fas fa-times-circle', 'Exit Fullscreen', 'danger', 'text')
        });
    }
    /**
     * @private
     * @param {?} toolbarItems
     * @return {?}
     */
    addMenus(toolbarItems) {
        toolbarItems.push({
            widget: 'dxMenu',
            location: 'after',
            options: {
                cssClass: 'dx-theme-border-color cc-data-grid-feature-menu',
                showFirstSubmenuMode: {
                    name: 'onHover',
                    delay: { show: 50, hide: 300 }
                },
                items: [
                    {
                        icon: 'fas fa-cog',
                        text: 'Configure',
                        items: [
                            {
                                icon: 'fas fa-grip-horizontal',
                                text: 'Switch To Toolbar Mode',
                                action: 'SwitchToToolbarMode',
                                visible: this.stylingMode === 'menu' &&
                                    this.gridFeatures.allowModeSwitch &&
                                    !this.isSmallScreen
                            },
                            {
                                icon: 'fas fa-long-arrow-alt-down',
                                text: 'Move Features To Bottom',
                                action: 'MoveFeaturesToBottom',
                                visible: this.gridFeatures.placement === 'top' &&
                                    this.gridFeatures.allowPlacementSwitch &&
                                    !this.isSmallScreen
                            },
                            {
                                icon: 'fas fa-long-arrow-alt-up',
                                text: 'Move Features To Top',
                                action: 'MoveFeaturesToTop',
                                visible: this.gridFeatures.placement === 'bottom' &&
                                    this.gridFeatures.allowPlacementSwitch &&
                                    !this.isSmallScreen
                            },
                            {
                                beginGroup: true,
                                icon: 'fas fa-search',
                                text: 'Show Search',
                                action: 'ShowSearch',
                                visible: this.gridFeatures.allowSearch && !this.isSearchVisible
                            },
                            {
                                icon: 'dx-theme-accent-as-text-color fas fa-search',
                                text: 'Hide Search',
                                action: 'HideSearch',
                                visible: this.gridFeatures.allowSearch && this.isSearchVisible
                            },
                            {
                                icon: 'far fa-plus-square',
                                text: 'Expand All',
                                action: 'ExpandAll',
                                visible: this.gridFeatures.allowExpandCollapse && this.hasGrouping && !this.isExpanded
                            },
                            {
                                icon: 'far fa-minus-square',
                                text: 'Collapse All',
                                action: 'CollapseAll',
                                visible: this.gridFeatures.allowExpandCollapse && this.hasGrouping && this.isExpanded
                            },
                            {
                                icon: 'columnchooser',
                                text: 'Column Chooser',
                                action: 'ColumnChooser',
                                visible: this.gridFeatures.allowColumnsSelector,
                                template: (/**
                                 * @param {?} itemData
                                 * @param {?} itemIndex
                                 * @param {?} itemElement
                                 * @return {?}
                                 */
                                (itemData, itemIndex, itemElement) => {
                                    /** @type {?} */
                                    const hasHidden = this.hasHiddenColumn();
                                    if (hasHidden) {
                                        return `<span class="cc-stack fa-stack">
                                              <i class="dx-icon dx-icon-columnchooser fa-stack-2x"></i>
                                              <i class="fas fa-star fa-stack-1x dx-theme-accent-as-text-color"></i>
                                            </span>
                                            <span class="dx-menu-item-text cc-menu-item-text">${itemData.text}</span>`;
                                    }
                                    else {
                                        return `<span class="cc-stack fa-stack">
                                              <i class="dx-icon dx-icon-columnchooser fa-stack-2x"></i>
                                            </span>
                                            <span class="dx-menu-item-text cc-menu-item-text">${itemData.text}</span>`;
                                    }
                                })
                            },
                            {
                                icon: 'fas fa-external-link-alt',
                                text: 'Fullscreen View',
                                action: 'FullscreenView',
                                visible: !this.isInFullScreen && this.gridFeatures.allowFullscreen
                            },
                            {
                                icon: 'fas fa-external-link-square-alt fa-rotate-180',
                                text: 'Normal View',
                                action: 'NormalView',
                                visible: this.isInFullScreen && this.gridFeatures.allowFullscreen
                            },
                            {
                                icon: 'fas fa-save',
                                text: 'Save Layout',
                                action: 'SaveGridState',
                                visible: this.hasStateSave && this.gridFeatures.allowSaveLayout
                            },
                            {
                                icon: 'fas fa-ban fa-flip-horizontal',
                                text: 'Reset Layout',
                                action: 'ResetLayout',
                                visible: this.gridFeatures.allowResetLayout
                            },
                            {
                                beginGroup: true,
                                icon: 'fas fa-file-export',
                                text: 'Export',
                                visible: this.gridFeatures.allowExcelExport || this.gridFeatures.allowCSVExport,
                                items: [
                                    {
                                        icon: 'fas fa-file-excel',
                                        text: 'Export to Excel',
                                        action: 'ExportToExcel',
                                        visible: this.gridFeatures.allowExcelExport
                                    },
                                    {
                                        icon: 'fas fa-file-csv',
                                        text: 'Export to CSV',
                                        action: 'ExportToCSV',
                                        visible: this.gridFeatures.allowCSVExport
                                    }
                                ]
                            },
                            {
                                icon: 'far fa-hand-pointer',
                                text: 'Enable Row Hot Track',
                                action: 'EnableRowHotTrack',
                                visible: !this.gridFeatures.allowRowTracking
                            },
                            {
                                icon: 'dx-theme-accent-as-text-color far fa-hand-pointer',
                                text: 'Disable Row Hot Track',
                                action: 'DisableRowHotTrack',
                                visible: this.gridFeatures.allowRowTracking
                            }
                        ]
                    }
                ],
                onItemClick: this.onMenuItemClick.bind(this)
            }
        }, {
            widget: 'dxButton',
            location: 'after',
            visible: this.isInFullScreen,
            options: this.getButtonOptions('fas fa-times-circle', 'Exit Fullscreen', 'danger', 'text')
        });
    }
    /**
     * @private
     * @param {?} action
     * @return {?}
     */
    onAction(action) {
        /** @type {?} */
        const instance = this.grid.instance;
        switch (action) {
            case 'ShowSearch':
                this.isSearchVisible = true;
                instance.option('searchPanel', {
                    visible: true,
                    searchVisibleColumnsOnly: true
                });
                this.repaint();
                break;
            case 'HideSearch':
                this.isSearchVisible = false;
                instance.option('searchPanel', {
                    visible: false,
                    searchVisibleColumnsOnly: true,
                    text: ''
                });
                this.repaint();
                break;
            case 'ExpandAll':
                this.isExpanded = true;
                instance.expandAll();
                this.repaint();
                break;
            case 'CollapseAll':
                this.isExpanded = false;
                instance.collapseAll();
                this.repaint();
                break;
            case 'ColumnChooser':
                instance.showColumnChooser();
                break;
            case 'ResetLayout':
                this.isExpanded = (instance.option('grouping') || { autoExpandAll: true }).autoExpandAll;
                this.isInitComplete = false;
                instance.state(null);
                this.viewTimerIds.push(setTimeout(this.removeGridState.bind(this), 100));
                this.viewTimerIds.push(setTimeout((/**
                 * @return {?}
                 */
                () => {
                    this.isInitComplete = true;
                    this.repaint();
                }), 2000));
                break;
            case 'EnableRowHotTrack':
            case 'DisableRowHotTrack':
                this.gridFeatures.allowRowTracking = !this.gridFeatures.allowRowTracking;
                /** @type {?} */
                const options = {
                    focusStateEnabled: this.gridFeatures.allowRowTracking,
                    hoverStateEnabled: this.gridFeatures.allowRowTracking
                };
                instance.option(options);
                this.repaint();
                break;
            case 'ExportToExcel':
            case 'ExportToCSV':
                this.exportMode = action === 'ExportToExcel' ? 'XLSX' : 'CSV';
                this.exportGridData(instance);
                break;
            case 'HideConfiguration':
                this.isIconsVisible = false;
                this.repaint();
                break;
            case 'ShowConfiguration':
                this.isIconsVisible = true;
                this.repaint();
                break;
            case 'FullscreenView':
            case 'NormalView':
                this.isInFullScreen = !this.isInFullScreen;
                this.repaint();
                break;
            case 'ExitFullscreen':
                this.isInFullScreen = false;
                this.repaint();
                break;
            case 'SaveGridState':
                /** @type {?} */
                const state = instance.state();
                this.saveGridState(state);
                break;
            case 'SwitchToMenuMode':
            case 'SwitchToToolbarMode':
                this.stylingMode = action === 'SwitchToMenuMode' ? 'menu' : 'toolbar';
                if (!this.isSmallScreen) {
                    this.gridFeatures.stylingMode = this.stylingMode;
                    this.saveStyleMode();
                }
                this.repaint();
                break;
            case 'MoveFeaturesToTop':
            case 'MoveFeaturesToBottom':
                /** @type {?} */
                const placement = action === 'MoveFeaturesToTop' ? 'top' : 'bottom';
                this.gridFeatures.placement = placement;
                this.saveStyleMode();
                this.repaint();
                break;
        }
    }
    /**
     * @private
     * @return {?}
     */
    loadStyleMode() {
        if (this.hasStateSave) {
            /** @type {?} */
            const data = JSON.parse(this.localStorageService.getItem(this.stateConfig.storageKey, CCLocalStorageCategory.DXGT)) || {};
            /** @type {?} */
            const stylingMode = this.gridFeatures.stylingMode !== 'hidden'
                ? data.stylingMode || this.gridFeatures.stylingMode
                : this.gridFeatures.stylingMode;
            this.gridFeatures.stylingMode = stylingMode;
            this.gridFeatures.placement = data.toolbarPlacement === 'bottom' ? 'bottom' : 'top';
        }
    }
    /**
     * @private
     * @return {?}
     */
    saveStyleMode() {
        if (this.hasStateSave) {
            /** @type {?} */
            const data = JSON.parse(this.localStorageService.getItem(this.stateConfig.storageKey, CCLocalStorageCategory.DXGT)) || {};
            /** @type {?} */
            const saved = Object.assign({}, data);
            data.stylingMode = this.gridFeatures.stylingMode;
            data.toolbarPlacement = this.gridFeatures.placement;
            if (this.hasDifference(saved, data)) {
                this.localStorageService.setItem(this.stateConfig.storageKey, JSON.stringify(data), CCLocalStorageCategory.DXGT);
            }
        }
    }
    /**
     * @private
     * @return {?}
     */
    getGridState() {
        if (this.hasStateSave) {
            /** @type {?} */
            const data = JSON.parse(this.localStorageService.getItem(this.stateConfig.storageKey, CCLocalStorageCategory.DXG)) ||
                {};
            /** @type {?} */
            const state = data.gridState;
            if (state) {
                this.updateGridState(state);
            }
            return state;
        }
        return null;
    }
    /**
     * @private
     * @param {?} state
     * @return {?}
     */
    updateGridState(state) {
        state.pageIndex = 0;
        state.focusedRowKey = -1;
        state.selectedRowKeys = []; // clear selection
        state.searchText = null; // always clear search text
        if (!this.stateConfig.storeFilters) {
            state.filterValue = null; // clear filter
        }
        state.columns.forEach((/**
         * @param {?} column
         * @return {?}
         */
        (column) => {
            if (!this.stateConfig.storeFilters) {
                column.filterValue = null;
                column.filterType = null;
                column.filterValues = null;
                column.selectedFilterOperation = null;
            }
            if (!this.stateConfig.storeSortings) {
                column.sortIndex = null;
                column.sortOrder = null;
            }
            if (!this.stateConfig.storeGroupings) {
                column.groupIndex = null;
            }
        }));
    }
    /**
     * @private
     * @param {?} state
     * @return {?}
     */
    saveGridState(state) {
        if (this.hasStateSave && this.isInitComplete) {
            /** @type {?} */
            const savedState = this.getGridState();
            if (state) {
                this.updateGridState(state);
            }
            if (this.hasDifference(savedState, state)) {
                /** @type {?} */
                const data = JSON.parse(this.localStorageService.getItem(this.stateConfig.storageKey, CCLocalStorageCategory.DXG)) || {};
                data.gridState = state;
                this.localStorageService.setItem(this.stateConfig.storageKey, JSON.stringify(data), CCLocalStorageCategory.DXG);
            }
        }
    }
    /**
     * @private
     * @return {?}
     */
    removeGridState() {
        if (this.hasStateSave) {
            this.localStorageService.removeItem(this.stateConfig.storageKey, CCLocalStorageCategory.DXG);
        }
        if (this.pagingConfig.visible) {
            if (!!this.pager) {
                this.pagingConfig.defaultPageSize = this.defaultPageSize;
                this.pager.onPageSizeChange({ value: this.defaultPageSize.toString() });
            }
            /** @type {?} */
            const state = this.grid.instance.state();
            state.pageSize = parseInt(this.defaultPageSize.toString());
            this.grid.instance.state(state);
        }
    }
    /**
     * @private
     * @return {?}
     */
    hasHiddenColumn() {
        /** @type {?} */
        const columns = (/** @type {?} */ (this.grid.instance.option('columns')));
        /** @type {?} */
        const visible = this.grid.instance
            .getVisibleColumns()
            .filter((/**
         * @param {?} col
         * @return {?}
         */
        (col) => col.type !== 'adaptive' &&
            col.type !== 'detailExpand' &&
            col.type !== 'selection' &&
            col.type !== 'buttons'));
        return visible.length !== columns.length - columns.filter((/**
         * @param {?} col
         * @return {?}
         */
        (col) => col.showInColumnChooser === false)).length;
    }
    /**
     * @private
     * @return {?}
     */
    onScreenSizeChange() {
        this.stylingMode = this.isSmallScreen ? 'menu' : this.gridFeatures.stylingMode;
        this.grid.instance.option('columnResizingMode', this.isSmallScreen ? 'nextColumn' : this.gridFeatures.columnResizingMode);
        this.grid.instance.refresh();
        if (this.stylingMode === 'menu') {
            this.onAction('SwitchToMenuMode');
        }
        else if (this.stylingMode === 'toolbar') {
            this.onAction('SwitchToToolbarMode');
            this.onAction('ShowConfiguration');
        }
        else if (this.stylingMode === 'toolbar-collapsed') {
            this.onAction('SwitchToToolbarMode');
            this.onAction('HideConfiguration');
        }
    }
    /**
     * @private
     * @param {?} value
     * @param {?} operation
     * @return {?}
     */
    wildcardFilterExpression(value, operation) {
        /** @type {?} */
        const column = (/** @type {?} */ (this));
        /**
         * @param {?} str
         * @param {?} rule
         * @return {?}
         */
        function matchRuleShort(str, rule) {
            return new RegExp(rule.replace('*', '.*').replace(/%/gi, '.*').toLowerCase()).test(typeof str === 'string' ? str.toLowerCase() : str);
        }
        if (value || operation) {
            if (!operation) {
                return [
                    (/**
                     * @param {?} data
                     * @return {?}
                     */
                    function (data) {
                        return matchRuleShort(column.calculateCellValue(data), value);
                    }),
                    '=',
                    true
                ];
            }
            else {
                return [column.dataField, operation, value];
            }
        }
    }
    /**
     * @private
     * @param {?} left
     * @param {?} right
     * @return {?}
     */
    hasDifference(left, right) {
        /** @type {?} */
        let hasDiff = typeof left !== typeof right;
        if (!hasDiff && left !== null && right !== null) {
            /** @type {?} */
            const leftKeys = Object.keys(left).sort();
            /** @type {?} */
            const rightKeys = Object.keys(right).sort();
            hasDiff = leftKeys.join() !== rightKeys.join();
            if (!hasDiff) {
                for (const key of leftKeys) {
                    /** @type {?} */
                    const leftVal = left[key];
                    /** @type {?} */
                    const rightVal = right[key];
                    hasDiff = typeof leftVal !== typeof rightVal;
                    if (!hasDiff) {
                        if (typeof leftVal === 'object') {
                            hasDiff = this.hasDifference(leftVal, rightVal);
                        }
                        else {
                            hasDiff = leftVal !== rightVal;
                        }
                    }
                    if (hasDiff) {
                        break;
                    }
                }
            }
        }
        return hasDiff;
    }
}
DataGridFeaturesComponent.decorators = [
    { type: Component, args: [{
                selector: 'cc-data-grid-features',
                template: "<dx-box\n    width=\"100%\"\n    height=\"100%\"\n    direction=\"col\"\n    class=\"cc-data-grid-feature\"\n    [ngClass]=\"{ 'cc-data-grid-fullscreen dx-theme-background-color dx-theme-border-color': isInFullScreen }\"\n>\n    <dxi-item [baseSize]=\"!useRatio ? 'auto' : undefined\" [ratio]=\"useRatio ? 1 : undefined\">\n        <ng-content></ng-content>\n    </dxi-item>\n    <dxi-item [baseSize]=\"4\" [visible]=\"pagingConfig?.visible\"></dxi-item>\n    <dxi-item [baseSize]=\"32\" [visible]=\"pagingConfig?.visible\">\n        <cc-data-grid-pager\n            [hasGrouping]=\"hasGrouping\"\n            [dataSource]=\"dataSource\"\n            [dataGrid]=\"grid\"\n            [pagingConfig]=\"pagingConfig\"\n            [toolbarItems]=\"pagingConfig?.toolbarItems\"\n        ></cc-data-grid-pager>\n    </dxi-item>\n</dx-box>\n",
                styles: [":host{width:100%;height:100%}.cc-data-grid-fullscreen{position:fixed;left:5px;right:5px;top:5px;height:98vh;z-index:1501;padding:0 10px;border:1px solid;border-radius:5px}.cc-data-grid-feature ::ng-deep .cc-data-grid-feature-menu{border:1px solid}.cc-data-grid-feature ::ng-deep .cc-data-grid-feature-menu:hover{border:none}.cc-data-grid-feature ::ng-deep .cc-stack.fa-stack{width:18px;height:16px}.cc-data-grid-feature ::ng-deep .cc-stack.fa-stack .fa-stack-2x{font-size:18px;width:18px;height:16px;line-height:1}.cc-data-grid-feature ::ng-deep .cc-stack.fa-stack .fa-stack-1x{font-size:12px;left:8px;top:-10px}.cc-data-grid-feature ::ng-deep .cc-icon.dx-icon,.cc-data-grid-feature ::ng-deep .cc-icon.far,.cc-data-grid-feature ::ng-deep .cc-icon.fas{font-size:18px;width:18px;height:16px;line-height:1}::ng-deep .cc-data-grid-feature-menu ::ng-deep .dx-menu-item-text.cc-menu-item-text{padding-left:3px!important}::ng-deep .cc-data-grid-feature-menu ::ng-deep .cc-stack.fa-stack{width:10px;height:12px}::ng-deep .cc-data-grid-feature-menu ::ng-deep .cc-stack.fa-stack .fa-stack-2x{font-size:16px;width:14px;height:14px;line-height:16px;margin-left:-2px}::ng-deep .cc-data-grid-feature-menu ::ng-deep .cc-stack.fa-stack .fa-stack-1x{font-size:10px;left:6px;top:-10px}"]
            }] }
];
/** @nocollapse */
DataGridFeaturesComponent.ctorParameters = () => [
    { type: CCScreenService },
    { type: CCLocalStorageService }
];
DataGridFeaturesComponent.propDecorators = {
    pager: [{ type: ViewChild, args: [DataGridPagerComponent, { static: false },] }],
    grid: [{ type: ContentChild, args: [DxDataGridComponent, { static: false },] }],
    dataSource: [{ type: Input }],
    gridFeatures: [{ type: Input }],
    stateConfig: [{ type: Input }],
    pagingConfig: [{ type: Input }],
    useRatio: [{ type: Input }],
    onEscapeKeyDown: [{ type: HostListener, args: ['document:keydown.escape', ['$event'],] }]
};
if (false) {
    /** @type {?} */
    DataGridFeaturesComponent.prototype.pager;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.grid;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.dataSource;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.gridFeatures;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.stateConfig;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.pagingConfig;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.useRatio;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.exportMode;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.isIconsVisible;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.isSearchVisible;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.defaultPageSize;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.isPageScroll;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.isExpanded;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.isInFullScreen;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.hasGrouping;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.hasStateSave;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.groupedColumns;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.offsetHeight;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.stylingMode;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.isSmallScreen;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.repaintTimerId;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.screenChangeSubscription;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.isInitComplete;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.viewSubscriptions;
    /** @type {?} */
    DataGridFeaturesComponent.prototype.viewTimerIds;
    /**
     * @type {?}
     * @private
     */
    DataGridFeaturesComponent.prototype.screenService;
    /**
     * @type {?}
     * @private
     */
    DataGridFeaturesComponent.prototype.localStorageService;
}
class CCDataGridFeaturesModule {
}
CCDataGridFeaturesModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                    DxScrollViewModule,
                    DxBoxModule,
                    DxDataGridModule,
                    DxToolbarModule,
                    DxButtonModule,
                    DxSelectBoxModule
                ],
                declarations: [DataGridFeaturesComponent, DataGridPagerComponent],
                exports: [DataGridFeaturesComponent, DataGridPagerComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SwitchComponent {
    constructor() {
        this.useYesNoText = true;
        this.width = 250;
        this.isDisabled = false;
        this.label = '';
        this.switchValueChange = new EventEmitter();
    }
    /**
     * @return {?}
     */
    getWidth() {
        return {
            width: this.width + 'px'
        };
    }
}
SwitchComponent.decorators = [
    { type: Component, args: [{
                selector: 'cc-switch',
                template: "<div [ngStyle]=\"getWidth()\">\n    <span style=\"margin-right: 10px\" class=\"normal-text\">{{ label }}</span>\n    <span style=\"float: right\">\n        <dx-switch\n            #ccSwitch\n            [disabled]=\"isDisabled\"\n            [value]=\"switchValue\"\n            (valueChange)=\"switchValueChange.emit($event)\"\n            [width]=\"50\"\n            [switchedOnText]=\"useYesNoText ? 'Yes' : 'On'\"\n            [switchedOffText]=\"useYesNoText ? 'No' : 'Off'\"\n        ></dx-switch>\n    </span>\n</div>\n",
                styles: [":host{width:100%;height:100%}"]
            }] }
];
SwitchComponent.propDecorators = {
    useYesNoText: [{ type: Input }],
    switchValue: [{ type: Input }],
    width: [{ type: Input }],
    isDisabled: [{ type: Input }],
    label: [{ type: Input }],
    switchValueChange: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    SwitchComponent.prototype.useYesNoText;
    /** @type {?} */
    SwitchComponent.prototype.switchValue;
    /** @type {?} */
    SwitchComponent.prototype.width;
    /** @type {?} */
    SwitchComponent.prototype.isDisabled;
    /** @type {?} */
    SwitchComponent.prototype.label;
    /** @type {?} */
    SwitchComponent.prototype.switchValueChange;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCDeviceService {
    /**
     * @param {?} deviceService
     */
    constructor(deviceService) {
        this.deviceService = deviceService;
        this.orientation = 0;
        this.subjectOrientationChanged = new Subject();
        if (!!window.screen && !!window.screen.orientation) {
            this.orientation = window.screen.orientation.angle;
            window.screen.orientation.onchange = (/**
             * @return {?}
             */
            () => {
                if (window.screen.orientation.angle !== this.orientation) {
                    this.orientation = window.screen.orientation.angle || 0;
                    this.subjectOrientationChanged.next(this.orientation);
                }
            });
        }
        else if (window.orientation !== null && window.orientation !== undefined) {
            this.orientation = window.orientation;
            window.onorientationchange = (/**
             * @return {?}
             */
            () => {
                // tslint:disable-next-line:triple-equals
                if (window.orientation != this.orientation) {
                    this.orientation = window.orientation || 0;
                    this.subjectOrientationChanged.next(this.orientation);
                }
            });
        }
    }
    /**
     * @return {?}
     */
    get deviceOrientation() {
        return this.orientation;
    }
    /**
     * @return {?}
     */
    get deviceInfomation() {
        if (this.deviceInfo === undefined) {
            this.deviceInfo = this.deviceService.getDeviceInfo();
        }
        return this.deviceInfo;
    }
    /**
     * @return {?}
     */
    isChrome() {
        if (this.deviceInfomation !== null) {
            return this.deviceInfomation.browser !== null && this.deviceInfomation.browser.toLowerCase() === 'chrome';
        }
        return false;
    }
    /**
     * @return {?}
     */
    isEdge() {
        if (this.deviceInfomation !== null) {
            return this.deviceInfomation.browser !== null && this.deviceInfomation.browser.toLowerCase() === 'ms-edge';
        }
        return false;
    }
    /**
     * @return {?}
     */
    isSafari() {
        if (this.deviceInfomation !== null) {
            return this.deviceInfomation.browser !== null && this.deviceInfomation.browser.toLowerCase() === 'safari';
        }
        return false;
    }
    /**
     * @return {?}
     */
    isMac() {
        if (this.deviceInfomation !== null) {
            return this.deviceInfomation.os !== null && this.deviceInfomation.os.toLowerCase().indexOf('mac') >= 0;
        }
        return false;
    }
    /**
     * @param {?} deviceType
     * @return {?}
     */
    isDeviceType(deviceType) {
        if (this.deviceInfomation !== null) {
            /** @type {?} */
            const device = this.deviceInfomation.device;
            if (device !== null) {
                return device.toLowerCase() === deviceType;
            }
        }
        return false;
    }
    /**
     * @return {?}
     */
    isIPhone() {
        return this.isDeviceType('iphone');
    }
    /**
     * @return {?}
     */
    isIPad() {
        return this.isDeviceType('ipad');
    }
    /**
     * @return {?}
     */
    isMobile() {
        return this.deviceService.isMobile();
    }
    /**
     * @return {?}
     */
    isTablet() {
        return this.deviceService.isTablet();
    }
    /**
     * @return {?}
     */
    isDesktop() {
        return this.deviceService.isDesktop();
    }
    /**
     * @return {?}
     */
    isPortrait() {
        return !this.isLandscape();
    }
    /**
     * @return {?}
     */
    isLandscape() {
        return Math.abs(parseInt(this.orientation.toString())) === 90;
    }
}
CCDeviceService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CCDeviceService.ctorParameters = () => [
    { type: DeviceDetectorService }
];
/** @nocollapse */ CCDeviceService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CCDeviceService_Factory() { return new CCDeviceService(ɵɵinject(DeviceDetectorService)); }, token: CCDeviceService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    CCDeviceService.prototype.deviceInfo;
    /**
     * @type {?}
     * @private
     */
    CCDeviceService.prototype.orientation;
    /** @type {?} */
    CCDeviceService.prototype.subjectOrientationChanged;
    /**
     * @type {?}
     * @private
     */
    CCDeviceService.prototype.deviceService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ImageEditorComponent {
    /**
     * @param {?} deviceService
     */
    constructor(deviceService) {
        this.deviceService = deviceService;
        this.width = '60%';
        this.height = '40%';
        this.title = '';
        this.allowDrag = true;
        this.allowResize = false;
        this.showCloseButton = true;
        this.imageEdited = new EventEmitter();
        this.visible = false;
        this.disableAction = true;
        this.showCropper = false;
        this.webcamAvailable = false;
        this.webcamVisible = false;
        this.isIOSDevice = false;
        this.webcamInfoVisible = false;
        this.clearImage = (/**
         * @return {?}
         */
        () => {
            this.selectedImageFile = null;
            this.selectedImageBase64 = null;
            this.showCropper = false;
            this.disableAction = true;
        });
        this.rotateLeft = (/**
         * @return {?}
         */
        () => {
            this.imageCropper.rotateLeft();
        });
        this.rotateRight = (/**
         * @return {?}
         */
        () => {
            this.imageCropper.rotateRight();
        });
        this.flipHorizontal = (/**
         * @return {?}
         */
        () => {
            this.imageCropper.flipHorizontal();
        });
        this.flipVertical = (/**
         * @return {?}
         */
        () => {
            this.imageCropper.flipVertical();
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.isIOSDevice = this.deviceService.isIPad() || this.deviceService.isIPhone();
        WebcamUtil.getAvailableVideoInputs()
            .then((/**
         * @param {?} mediaDevices
         * @return {?}
         */
        (mediaDevices) => {
            this.webcamAvailable = mediaDevices && mediaDevices.length > 0;
        }))
            .catch((/**
         * @param {?} err
         * @return {?}
         */
        (err) => {
            notify(err, 'error');
        }));
    }
    /**
     * @return {?}
     */
    show() {
        this.clearImage();
        this.visible = true;
    }
    /**
     * @return {?}
     */
    hide() {
        this.visible = false;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    hiding(event) {
        this.selectedImageFile = null;
        this.selectedImageBase64 = null;
        this.showCropper = false;
    }
    /**
     * @return {?}
     */
    showTitle() {
        return !(this.title === undefined || this.title == null || this.title === '');
    }
    /**
     * @param {?} event
     * @return {?}
     */
    imageFileSelected(event) {
        this.selectedImageFile = null;
        this.selectedImageBase64 = null;
        if (event.value != null && event.value.length > 0) {
            this.selectedImageFile = event.value[0];
            this.disableAction = false;
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    imageCropped(event) {
        this.imageEdited.emit(event.base64);
    }
    /**
     * @return {?}
     */
    imageLoaded() {
        // show cropper
        this.showCropper = true;
    }
    /**
     * @return {?}
     */
    cropperReady() {
        // cropper ready
    }
    /**
     * @return {?}
     */
    loadImageFailed() {
        // show message
    }
    /**
     * @return {?}
     */
    cropImage() {
        this.imageCropper.crop();
    }
    /**
     * @return {?}
     */
    showWebcam() {
        this.webcamVisible = true;
        this.showWebcamInfo();
    }
    /**
     * @return {?}
     */
    hideWebcam() {
        this.webcamVisible = false;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    webcamImageCaptured(data) {
        this.selectedImageFile = null;
        this.selectedImageBase64 = null;
        if (!!data) {
            this.selectedImageBase64 = data;
            this.disableAction = false;
        }
        this.hideWebcam();
    }
    /**
     * @return {?}
     */
    webcamClosed() {
        this.webcamVisible = false;
    }
    /**
     * @return {?}
     */
    showWebcamInfo() {
        if (this.isIOSDevice) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.webcamInfoVisible = true;
            }), 500);
        }
    }
    /**
     * @return {?}
     */
    closeWebcamInfo() {
        this.webcamInfoVisible = false;
    }
}
ImageEditorComponent.decorators = [
    { type: Component, args: [{
                selector: 'cc-image-editor',
                template: "<dx-popup\n    [width]=\"width\"\n    [height]=\"height\"\n    [showTitle]=\"showTitle()\"\n    [title]=\"title\"\n    [dragEnabled]=\"allowDrag\"\n    [resizeEnabled]=\"allowResize\"\n    [showCloseButton]=\"showCloseButton\"\n    [(visible)]=\"visible\"\n    (onHiding)=\"hiding($event)\"\n>\n    <div *dxTemplate=\"let data of 'content'\">\n        <dx-box [visible]=\"!webcamVisible\" direction=\"col\" height=\"100%\" width=\"100%\">\n            <dxi-item [ratio]=\"1\">\n                <div *ngIf=\"disableAction\">\n                    <dx-box direction=\"row\" height=\"100%\" width=\"100%\" align=\"center\" crossAlign=\"center\">\n                        <dxi-item baseSize=\"auto\" *ngIf=\"webcamAvailable\">\n                            <dx-button icon=\"photo\" (onClick)=\"showWebcam()\" hint=\"Camera\"></dx-button>\n                        </dxi-item>\n                        <dxi-item [ratio]=\"1\">\n                            <dx-file-uploader\n                                class=\"drop-zone-border dx-theme-border-color\"\n                                [width]=\"240\"\n                                selectButtonText=\"Browse\"\n                                labelText=\"or Drop file here\"\n                                accept=\"image/*\"\n                                [allowedFileExtensions]=\"['.jpg', '.jpeg', '.gif', '.png']\"\n                                uploadMode=\"useForm\"\n                                [showFileList]=\"false\"\n                                [allowCanceling]=\"false\"\n                                (onValueChanged)=\"imageFileSelected($event)\"\n                            ></dx-file-uploader>\n                        </dxi-item>\n                        <dxi-item baseSize=\"auto\" *ngIf=\"isIOSDevice\">\n                            <dx-button\n                                class=\"camera-information-button\"\n                                type=\"default\"\n                                icon=\"info\"\n                                hint=\"Camera Information\"\n                                (onClick)=\"showWebcamInfo()\"\n                            ></dx-button>\n                        </dxi-item>\n                    </dx-box>\n                </div>\n\n                <div *ngIf=\"!disableAction\">\n                    <dx-toolbar>\n                        <dxi-item\n                            location=\"center\"\n                            widget=\"dxButton\"\n                            [options]=\"{\n                                icon: 'revert',\n                                hint: 'Rotate Left',\n                                onClick: rotateLeft\n                            }\"\n                        ></dxi-item>\n                        <dxi-item\n                            location=\"center\"\n                            widget=\"dxButton\"\n                            [options]=\"{\n                                icon: 'redo',\n                                hint: 'Rotate Right',\n                                onClick: rotateRight\n                            }\"\n                        ></dxi-item>\n                        <dxi-item\n                            location=\"center\"\n                            widget=\"dxButton\"\n                            [options]=\"{\n                                icon: 'chevronnext',\n                                hint: 'Flip Horizontal',\n                                onClick: flipHorizontal\n                            }\"\n                        ></dxi-item>\n                        <dxi-item\n                            location=\"center\"\n                            widget=\"dxButton\"\n                            [options]=\"{\n                                icon: 'chevrondown',\n                                hint: 'Flip Vertical',\n                                onClick: flipVertical\n                            }\"\n                        ></dxi-item>\n                        <dxi-item\n                            location=\"center\"\n                            widget=\"dxButton\"\n                            [options]=\"{\n                                icon: 'clear',\n                                hint: 'Clear Image',\n                                onClick: clearImage\n                            }\"\n                        ></dxi-item>\n                    </dx-toolbar>\n                </div>\n                <div class=\"image-cropper-container\">\n                    <image-cropper\n                        #ccImageCropper\n                        class=\"image-cropper\"\n                        [imageFileChanged]=\"selectedImageFile\"\n                        [imageBase64]=\"selectedImageBase64\"\n                        [maintainAspectRatio]=\"true\"\n                        [aspectRatio]=\"1 / 1\"\n                        [resizeToWidth]=\"128\"\n                        [cropperMinWidth]=\"128\"\n                        [roundCropper]=\"true\"\n                        [autoCrop]=\"false\"\n                        format=\"png\"\n                        outputType=\"base64\"\n                        (imageCropped)=\"imageCropped($event)\"\n                        (imageLoaded)=\"imageLoaded()\"\n                        (cropperReady)=\"cropperReady()\"\n                        (loadImageFailed)=\"loadImageFailed()\"\n                        [style.display]=\"showCropper ? null : 'none'\"\n                    ></image-cropper>\n                </div>\n            </dxi-item>\n            <dxi-item baseSize=\"auto\">\n                <dx-box direction=\"row\" width=\"100%\" align=\"end\" crossAlign=\"center\">\n                    <dxi-item [ratio]=\"1\">\n                        <dx-button type=\"default\" [width]=\"100\" text=\"Cancel\" (onClick)=\"hide()\"></dx-button>\n                    </dxi-item>\n                    <dxi-item baseSize=\"auto\">\n                        <dx-button\n                            type=\"success\"\n                            [width]=\"100\"\n                            text=\"Crop & Save\"\n                            [disabled]=\"disableAction\"\n                            (onClick)=\"cropImage()\"\n                        ></dx-button>\n                    </dxi-item>\n                </dx-box>\n            </dxi-item>\n        </dx-box>\n        <cc-web-cam\n            [visible]=\"webcamVisible\"\n            (imageCaptured)=\"webcamImageCaptured($event)\"\n            (closed)=\"webcamClosed()\"\n        ></cc-web-cam>\n    </div>\n</dx-popup>\n\n<dx-popup\n    [width]=\"width\"\n    [height]=\"height\"\n    [showTitle]=\"true\"\n    title=\"Camera Information\"\n    [dragEnabled]=\"true\"\n    [resizeEnabled]=\"true\"\n    [showCloseButton]=\"true\"\n    [visible]=\"webcamInfoVisible\"\n>\n    <dx-box width=\"100%\" height=\"100%\" direction=\"col\">\n        <dxi-item [ratio]=\"1\">\n            <div class=\"camera-information-items-center\">\n                <h4>Make sure to hold your device as shown in below image</h4>\n                <img\n                    alt=\"\"\n                    src=\"data:image/svg+xml;base64,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\"\n                />\n            </div>\n        </dxi-item>\n        <dxi-item baseSize=\"auto\">\n            <div class=\"camera-information-items-center\">\n                <dx-button\n                    [width]=\"100\"\n                    text=\"Ok\"\n                    icon=\"fas fa-check\"\n                    type=\"default\"\n                    (onClick)=\"closeWebcamInfo()\"\n                ></dx-button>\n            </div>\n        </dxi-item>\n    </dx-box>\n</dx-popup>\n",
                styles: [".image-cropper{max-width:640px;max-height:480px}.image-cropper-container{display:flex;justify-content:center;width:100%;height:88%!important}.camera-information-button{border-radius:50%;max-width:24px;max-height:24px}.camera-information-button .dx-button-content .dx-icon{line-height:.9;margin-left:-1px}.camera-information-items-center{align-items:center;text-align:center;justify-items:center}.camera-information-items-center img{height:200px;margin-top:-45px;transform:rotate(-90deg)}.drop-zone-border{border:1px dotted}"]
            }] }
];
/** @nocollapse */
ImageEditorComponent.ctorParameters = () => [
    { type: CCDeviceService }
];
ImageEditorComponent.propDecorators = {
    width: [{ type: Input }],
    height: [{ type: Input }],
    title: [{ type: Input }],
    allowDrag: [{ type: Input }],
    allowResize: [{ type: Input }],
    showCloseButton: [{ type: Input }],
    imageEdited: [{ type: Output }],
    imageCropper: [{ type: ViewChild, args: ['ccImageCropper', { static: false },] }]
};
if (false) {
    /** @type {?} */
    ImageEditorComponent.prototype.width;
    /** @type {?} */
    ImageEditorComponent.prototype.height;
    /** @type {?} */
    ImageEditorComponent.prototype.title;
    /** @type {?} */
    ImageEditorComponent.prototype.allowDrag;
    /** @type {?} */
    ImageEditorComponent.prototype.allowResize;
    /** @type {?} */
    ImageEditorComponent.prototype.showCloseButton;
    /** @type {?} */
    ImageEditorComponent.prototype.imageEdited;
    /** @type {?} */
    ImageEditorComponent.prototype.visible;
    /** @type {?} */
    ImageEditorComponent.prototype.disableAction;
    /** @type {?} */
    ImageEditorComponent.prototype.selectedImageFile;
    /** @type {?} */
    ImageEditorComponent.prototype.selectedImageBase64;
    /** @type {?} */
    ImageEditorComponent.prototype.showCropper;
    /** @type {?} */
    ImageEditorComponent.prototype.webcamAvailable;
    /** @type {?} */
    ImageEditorComponent.prototype.webcamVisible;
    /** @type {?} */
    ImageEditorComponent.prototype.isIOSDevice;
    /** @type {?} */
    ImageEditorComponent.prototype.webcamInfoVisible;
    /** @type {?} */
    ImageEditorComponent.prototype.imageCropper;
    /** @type {?} */
    ImageEditorComponent.prototype.clearImage;
    /** @type {?} */
    ImageEditorComponent.prototype.rotateLeft;
    /** @type {?} */
    ImageEditorComponent.prototype.rotateRight;
    /** @type {?} */
    ImageEditorComponent.prototype.flipHorizontal;
    /** @type {?} */
    ImageEditorComponent.prototype.flipVertical;
    /**
     * @type {?}
     * @private
     */
    ImageEditorComponent.prototype.deviceService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class WebCamComponent {
    /**
     * @param {?} deviceService
     */
    constructor(deviceService) {
        this.deviceService = deviceService;
        this.visible = true;
        this.allowCameraSwitch = true;
        this.imageCaptured = new EventEmitter();
        this.closed = new EventEmitter();
        this.multipleWebCamsAvailable = false;
        this.videoOptions = {};
        this.errors = [];
        this.webcamImage = null;
        this._trigger = new Subject();
        this._nextWebcam = new Subject();
        this.clearImage = (/**
         * @return {?}
         */
        () => {
            this.webcamImage = null;
        });
        this.switchOffCamera = (/**
         * @return {?}
         */
        () => {
            this.hide();
        });
        this.clickCamera = (/**
         * @return {?}
         */
        () => {
            this.takePicture();
        });
        this.switchCamera = (/**
         * @return {?}
         */
        () => {
            this.showNextWebcam(true);
        });
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        /** @type {?} */
        const isEnumerateDevicesEligible = !(this.deviceService.isChrome() &&
            (this.deviceService.isMobile() || this.deviceService.isTablet()));
        if (isEnumerateDevicesEligible) {
            WebcamUtil.getAvailableVideoInputs()
                .then((/**
             * @param {?} mediaDevices
             * @return {?}
             */
            (mediaDevices) => {
                this.multipleWebCamsAvailable = mediaDevices && mediaDevices.length > 1;
            }))
                .catch((/**
             * @param {?} err
             * @return {?}
             */
            (err) => {
                notify(err, 'error');
            }));
        }
    }
    /**
     * @return {?}
     */
    show() {
        this.clearImage();
        this.visible = true;
    }
    /**
     * @return {?}
     */
    hide() {
        this.visible = false;
        this.closed.emit();
    }
    /**
     * @return {?}
     */
    takePicture() {
        this._trigger.next();
    }
    /**
     * @param {?} directionOrDeviceId
     * @return {?}
     */
    showNextWebcam(directionOrDeviceId) {
        // true => move forward through devices
        // false => move backwards through devices
        // string => move to device with given deviceId
        this._nextWebcam.next(directionOrDeviceId);
    }
    /**
     * @param {?} error
     * @return {?}
     */
    handleInitError(error) {
        this.errors.push(error);
    }
    /**
     * @param {?} webcamImage
     * @return {?}
     */
    handleImage(webcamImage) {
        this.webcamImage = webcamImage;
        this.imageCaptured.emit(webcamImage.imageAsDataUrl);
    }
    /**
     * @param {?} deviceId
     * @return {?}
     */
    handleCameraSwitched(deviceId) {
        this.deviceId = deviceId;
    }
    /**
     * @param {?} directionOrDeviceId
     * @return {?}
     */
    handleShowNextWebcam(directionOrDeviceId) {
        this._nextWebcam.next(directionOrDeviceId);
    }
    /**
     * @return {?}
     */
    get triggerObservable() {
        return this._trigger.asObservable();
    }
    /**
     * @return {?}
     */
    get nextWebcamObservable() {
        return this._nextWebcam.asObservable();
    }
}
WebCamComponent.decorators = [
    { type: Component, args: [{
                selector: 'cc-web-cam',
                template: "<dx-box direction=\"col\" height=\"100%\" width=\"100%\" *ngIf=\"visible\" align=\"center\" crossAlign=\"center\">\n    <dxi-item [ratio]=\"1\">\n        <webcam\n            [allowCameraSwitch]=\"allowCameraSwitch\"\n            [videoOptions]=\"videoOptions\"\n            [imageQuality]=\"1\"\n            [trigger]=\"triggerObservable\"\n            [switchCamera]=\"nextWebcamObservable\"\n            (imageCapture)=\"handleImage($event)\"\n            (cameraSwitched)=\"handleCameraSwitched($event)\"\n            (initError)=\"handleInitError($event)\"\n        ></webcam>\n    </dxi-item>\n    <dxi-item baseSize=\"auto\">\n        <dx-toolbar>\n            <dxi-item\n                *ngIf=\"multipleWebCamsAvailable\"\n                location=\"center\"\n                widget=\"dxButton\"\n                [options]=\"{\n                    icon: 'refresh',\n                    stylingMode: 'contained',\n                    hint: 'Switch camera',\n                    onClick: switchCamera\n                }\"\n            ></dxi-item>\n            <dxi-item\n                location=\"center\"\n                widget=\"dxButton\"\n                [options]=\"{\n                    icon: 'isnotblank',\n                    stylingMode: 'contained',\n                    hint: 'Take picture',\n                    onClick: clickCamera\n                }\"\n            ></dxi-item>\n            <dxi-item\n                location=\"center\"\n                widget=\"dxButton\"\n                [options]=\"{\n                    icon: 'clear',\n                    stylingMode: 'contained',\n                    hint: 'Close',\n                    onClick: switchOffCamera\n                }\"\n            ></dxi-item>\n        </dx-toolbar>\n    </dxi-item>\n</dx-box>\n",
                styles: [":host{width:100%;height:100%}"]
            }] }
];
/** @nocollapse */
WebCamComponent.ctorParameters = () => [
    { type: CCDeviceService }
];
WebCamComponent.propDecorators = {
    visible: [{ type: Input }],
    allowCameraSwitch: [{ type: Input }],
    imageCaptured: [{ type: Output }],
    closed: [{ type: Output }]
};
if (false) {
    /** @type {?} */
    WebCamComponent.prototype.visible;
    /** @type {?} */
    WebCamComponent.prototype.allowCameraSwitch;
    /** @type {?} */
    WebCamComponent.prototype.imageCaptured;
    /** @type {?} */
    WebCamComponent.prototype.closed;
    /** @type {?} */
    WebCamComponent.prototype.multipleWebCamsAvailable;
    /** @type {?} */
    WebCamComponent.prototype.deviceId;
    /** @type {?} */
    WebCamComponent.prototype.videoOptions;
    /** @type {?} */
    WebCamComponent.prototype.errors;
    /** @type {?} */
    WebCamComponent.prototype.webcamImage;
    /**
     * @type {?}
     * @private
     */
    WebCamComponent.prototype._trigger;
    /**
     * @type {?}
     * @private
     */
    WebCamComponent.prototype._nextWebcam;
    /** @type {?} */
    WebCamComponent.prototype.clearImage;
    /** @type {?} */
    WebCamComponent.prototype.switchOffCamera;
    /** @type {?} */
    WebCamComponent.prototype.clickCamera;
    /** @type {?} */
    WebCamComponent.prototype.switchCamera;
    /**
     * @type {?}
     * @private
     */
    WebCamComponent.prototype.deviceService;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @enum {number} */
const CCMessageBoxIcon = {
    error: 0,
    success: 1,
    warning: 2,
    info: 3,
};
CCMessageBoxIcon[CCMessageBoxIcon.error] = 'error';
CCMessageBoxIcon[CCMessageBoxIcon.success] = 'success';
CCMessageBoxIcon[CCMessageBoxIcon.warning] = 'warning';
CCMessageBoxIcon[CCMessageBoxIcon.info] = 'info';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MessageBoxComponent {
    constructor() {
        this.isShowPopupMessage = false;
        this.popupMessageTitle = '';
        this.popupMessageContent = '';
        this.popupWidth = 250;
    }
    /**
     * @param {?} icon
     * @param {?=} iconSize
     * @return {?}
     */
    static getHeaderIcon(icon, iconSize = 'icon-sm') {
        /** @type {?} */
        let headerIcon = ``;
        if (icon === CCMessageBoxIcon.error) {
            headerIcon = `<i class="fas fa-exclamation-circle icon-popup-header-error ${iconSize}"></i>`;
        }
        else if (icon === CCMessageBoxIcon.success) {
            headerIcon = `<i class="fas fa-check-circle icon-popup-header-success ${iconSize}"></i>`;
        }
        else if (icon === CCMessageBoxIcon.warning) {
            headerIcon = `<i class="fas fa-exclamation-triangle icon-popup-header-warning ${iconSize}"></i>`;
        }
        else if (icon === CCMessageBoxIcon.info) {
            headerIcon = `<i class="fas fa-info-circle icon-popup-header-info ${iconSize}"></i>`;
        }
        return headerIcon;
    }
    /**
     * @param {?} title
     * @param {?} content
     * @param {?=} callback
     * @return {?}
     */
    showErrorMessage(title, content, callback) {
        this.headerIcon = MessageBoxComponent.getHeaderIcon(CCMessageBoxIcon.error);
        this.show(title, content, callback);
    }
    /**
     * @param {?} title
     * @param {?} content
     * @param {?=} callback
     * @return {?}
     */
    showSuccessMessage(title, content, callback) {
        this.headerIcon = MessageBoxComponent.getHeaderIcon(CCMessageBoxIcon.success);
        this.show(title, content, callback);
    }
    /**
     * @param {?} title
     * @param {?} content
     * @param {?=} callback
     * @return {?}
     */
    showWarningMessage(title, content, callback) {
        this.headerIcon = MessageBoxComponent.getHeaderIcon(CCMessageBoxIcon.warning);
        this.show(title, content, callback);
    }
    /**
     * @param {?} title
     * @param {?} content
     * @param {?=} callback
     * @return {?}
     */
    showInfoMessage(title, content, callback) {
        this.headerIcon = MessageBoxComponent.getHeaderIcon(CCMessageBoxIcon.info);
        this.show(title, content, callback);
    }
    // this is kept for quick testing without needing to build cc-common
    /**
     * @param {?} htmlContentForIcon
     * @param {?} title
     * @param {?} content
     * @param {?=} callback
     * @return {?}
     */
    showPopupTesting(htmlContentForIcon, title, content, callback) {
        this.headerIcon = htmlContentForIcon;
        this.show(title, content, callback);
    }
    /**
     * @param {?} icon
     * @param {?} title
     * @param {?} content
     * @param {?} popupWidth
     * @param {?=} callback
     * @return {?}
     */
    showWithIcon(icon, title, content, popupWidth, callback) {
        this.headerIcon = MessageBoxComponent.getHeaderIcon(icon);
        this.show(title, content, callback);
    }
    /**
     * @param {?} title
     * @param {?} content
     * @param {?} popupWidth
     * @param {?=} callback
     * @return {?}
     */
    showWithFixedWidth(title, content, popupWidth, callback) {
        this.popupWidth = popupWidth;
        this.show(title, content, callback);
    }
    /**
     * @param {?} icon
     * @param {?} title
     * @param {?} content
     * @param {?} popupWidth
     * @param {?=} callback
     * @return {?}
     */
    showWithFixedWidthAndIcon(icon, title, content, popupWidth, callback) {
        this.headerIcon = MessageBoxComponent.getHeaderIcon(icon);
        this.showWithFixedWidth(title, content, popupWidth, callback);
    }
    /**
     * @return {?}
     */
    hide() {
        this.isShowPopupMessage = false;
        if (this.callbackOnClose != null && typeof this.callbackOnClose === 'function') {
            this.callbackOnClose();
        }
    }
    /**
     * @return {?}
     */
    btnCloseClick() {
        this.hide();
    }
    /**
     * @private
     * @param {?} title
     * @param {?} content
     * @param {?=} callback
     * @return {?}
     */
    show(title, content, callback) {
        this.isShowPopupMessage = true;
        this.popupMessageTitle = title;
        this.popupMessageContent = content;
        this.callbackOnClose = callback;
    }
}
MessageBoxComponent.decorators = [
    { type: Component, args: [{
                selector: 'cc-message-box',
                template: "<dx-popup\n    class=\"popup-info\"\n    [width]=\"popupWidth\"\n    height=\"auto\"\n    [showTitle]=\"true\"\n    titleTemplate=\"title\"\n    [dragEnabled]=\"true\"\n    [showCloseButton]=\"true\"\n    [closeOnOutsideClick]=\"false\"\n    [(visible)]=\"isShowPopupMessage\"\n    (onHidden)=\"hide()\"\n>\n    <div *dxTemplate=\"let data of 'content'\">\n        <div [innerHTML]=\"popupMessageContent\"></div>\n        <div style=\"margin-top: 15px; float: right; padding-right: 10px; padding-bottom: 10px;\">\n            <dx-button type=\"default\" text=\"Close\" (click)=\"btnCloseClick()\"></dx-button>\n        </div>\n    </div>\n    <div *dxTemplate=\"let data of 'title'\">\n        <span [innerHTML]=\"headerIcon\"></span>\n        {{ popupMessageTitle }}\n    </div>\n</dx-popup>\n",
                styles: ['../../assets/css/cc-common-styles.css']
            }] }
];
if (false) {
    /** @type {?} */
    MessageBoxComponent.prototype.isShowPopupMessage;
    /** @type {?} */
    MessageBoxComponent.prototype.popupMessageTitle;
    /** @type {?} */
    MessageBoxComponent.prototype.popupMessageContent;
    /** @type {?} */
    MessageBoxComponent.prototype.popupWidth;
    /** @type {?} */
    MessageBoxComponent.prototype.callbackOnClose;
    /** @type {?} */
    MessageBoxComponent.prototype.headerIcon;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtcToUserTimezonePipe {
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    transform(value, args) {
        /** @type {?} */
        let userTimezone;
        if (!!args) {
            userTimezone = args;
        }
        if (!userTimezone) {
            // Guess user timezone
            userTimezone = tz.guess(true);
        }
        // Convert and return datetime without timezone information
        return tz(value, 'UTC').tz(userTimezone).format('YYYY-MM-DDTHH:mm:ss');
    }
}
UtcToUserTimezonePipe.decorators = [
    { type: Pipe, args: [{
                name: 'ccUtcUtz'
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SafeHtmlPipe {
    /**
     * @param {?} sanitizer
     */
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        return this.sanitizer.bypassSecurityTrustHtml(value);
    }
}
SafeHtmlPipe.decorators = [
    { type: Pipe, args: [{
                name: 'ccSafeHtml'
            },] }
];
/** @nocollapse */
SafeHtmlPipe.ctorParameters = () => [
    { type: DomSanitizer }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    SafeHtmlPipe.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TimezoneConstants {
    /**
     * @param {?} value
     * @return {?}
     */
    static displayValue(value) {
        return value.replace('Standard ', '');
    }
}
TimezoneConstants.abbreviations = [
    {
        value: 'Dateline Daylight Time',
        abbr: 'DST',
        offset: -12,
        isdst: false,
        text: '(UTC-12:00) International Date Line West',
        utc: ['Etc/GMT+12']
    },
    {
        value: 'UTC-11',
        abbr: 'U',
        offset: -11,
        isdst: false,
        text: '(UTC-11:00) Coordinated Universal Time-11',
        utc: ['Etc/GMT+11', 'Pacific/Midway', 'Pacific/Niue', 'Pacific/Pago_Pago']
    },
    {
        value: 'Hawaiian Standard Time',
        abbr: 'HST',
        offset: -10,
        isdst: false,
        text: '(UTC-10:00) Hawaii',
        utc: ['Etc/GMT+10', 'Pacific/Honolulu', 'Pacific/Johnston', 'Pacific/Rarotonga', 'Pacific/Tahiti']
    },
    {
        value: 'Alaskan Daylight Time',
        abbr: 'AKDT',
        offset: -8,
        isdst: true,
        text: '(UTC-09:00) Alaska',
        utc: ['America/Anchorage', 'America/Juneau', 'America/Nome', 'America/Sitka', 'America/Yakutat']
    },
    {
        value: 'Pacific Daylight Time (Mexico)',
        abbr: 'PDT',
        offset: -7,
        isdst: true,
        text: '(UTC-08:00) Baja California',
        utc: ['America/Santa_Isabel']
    },
    {
        value: 'Pacific Daylight Time',
        abbr: 'PDT',
        offset: -7,
        isdst: true,
        text: '(UTC-07:00) Pacific Time (US & Canada)',
        utc: ['America/Dawson', 'America/Los_Angeles', 'America/Tijuana', 'America/Vancouver', 'America/Whitehorse']
    },
    {
        value: 'Pacific Standard Time',
        abbr: 'PST',
        offset: -8,
        isdst: false,
        text: '(UTC-08:00) Pacific Time (US & Canada)',
        utc: [
            'America/Dawson',
            'America/Los_Angeles',
            'America/Tijuana',
            'America/Vancouver',
            'America/Whitehorse',
            'PST8PDT'
        ]
    },
    {
        value: 'US Mountain Standard Time',
        abbr: 'UMST',
        offset: -7,
        isdst: false,
        text: '(UTC-07:00) Arizona',
        utc: ['America/Creston', 'America/Dawson_Creek', 'America/Hermosillo', 'America/Phoenix', 'Etc/GMT+7']
    },
    {
        value: 'Mountain Daylight Time (Mexico)',
        abbr: 'MDT',
        offset: -6,
        isdst: true,
        text: '(UTC-07:00) Chihuahua, La Paz, Mazatlan',
        utc: ['America/Chihuahua', 'America/Mazatlan']
    },
    {
        value: 'Mountain Daylight Time',
        abbr: 'MDT',
        offset: -6,
        isdst: true,
        text: '(UTC-07:00) Mountain Time (US & Canada)',
        utc: [
            'America/Boise',
            'America/Cambridge_Bay',
            'America/Denver',
            'America/Edmonton',
            'America/Inuvik',
            'America/Ojinaga',
            'America/Yellowknife',
            'MST7MDT'
        ]
    },
    {
        value: 'Central Standard Time',
        abbr: 'CST',
        offset: -6,
        isdst: false,
        text: '(UTC-06:00) Central America',
        utc: [
            'America/Belize',
            'America/Costa_Rica',
            'America/El_Salvador',
            'America/Guatemala',
            'America/Managua',
            'America/Tegucigalpa',
            'Etc/GMT+6',
            'Pacific/Galapagos'
        ]
    },
    {
        value: 'Central Daylight Time',
        abbr: 'CDT',
        offset: -5,
        isdst: true,
        text: '(UTC-06:00) Central Time (US & Canada)',
        utc: [
            'America/Chicago',
            'America/Indiana/Knox',
            'America/Indiana/Tell_City',
            'America/Matamoros',
            'America/Menominee',
            'America/North_Dakota/Beulah',
            'America/North_Dakota/Center',
            'America/North_Dakota/New_Salem',
            'America/Rainy_River',
            'America/Rankin_Inlet',
            'America/Resolute',
            'America/Winnipeg',
            'CST6CDT'
        ]
    },
    {
        value: 'Central Daylight Time (Mexico)',
        abbr: 'CDT',
        offset: -5,
        isdst: true,
        text: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
        utc: [
            'America/Bahia_Banderas',
            'America/Cancun',
            'America/Merida',
            'America/Mexico_City',
            'America/Monterrey'
        ]
    },
    {
        value: 'Canada Central Standard Time',
        abbr: 'CCST',
        offset: -6,
        isdst: false,
        text: '(UTC-06:00) Saskatchewan',
        utc: ['America/Regina', 'America/Swift_Current']
    },
    {
        value: 'SA Pacific Standard Time',
        abbr: 'SPST',
        offset: -5,
        isdst: true,
        text: '(UTC-05:00) Bogota, Lima, Quito',
        utc: [
            'America/Bogota',
            'America/Cayman',
            'America/Coral_Harbour',
            'America/Eirunepe',
            'America/Guayaquil',
            'America/Jamaica',
            'America/Lima',
            'America/Panama',
            'America/Rio_Branco',
            'Etc/GMT+5'
        ]
    },
    {
        value: 'Eastern Standard Time',
        abbr: 'EST',
        offset: -5,
        isdst: false,
        text: '(UTC-05:00) Eastern Time (US & Canada)',
        utc: [
            'America/Detroit',
            'America/Havana',
            'America/Indiana/Petersburg',
            'America/Indiana/Vincennes',
            'America/Indiana/Winamac',
            'America/Iqaluit',
            'America/Kentucky/Monticello',
            'America/Louisville',
            'America/Montreal',
            'America/Nassau',
            'America/New_York',
            'America/Nipigon',
            'America/Pangnirtung',
            'America/Port-au-Prince',
            'America/Thunder_Bay',
            'America/Toronto',
            'EST5EDT'
        ]
    },
    {
        value: 'US Eastern Daylight Time',
        abbr: 'UEDT',
        offset: -4,
        isdst: true,
        text: '(UTC-05:00) Indiana (East)',
        utc: ['America/Indiana/Marengo', 'America/Indiana/Vevay', 'America/Indianapolis']
    },
    {
        value: 'Venezuela Standard Time',
        abbr: 'VST',
        offset: -4.5,
        isdst: false,
        text: '(UTC-04:30) Caracas',
        utc: ['America/Caracas']
    },
    {
        value: 'Paraguay Standard Time',
        abbr: 'PYT',
        offset: -4,
        isdst: false,
        text: '(UTC-04:00) Asuncion',
        utc: ['America/Asuncion']
    },
    {
        value: 'Atlantic Daylight Time',
        abbr: 'ADT',
        offset: -3,
        isdst: true,
        text: '(UTC-04:00) Atlantic Time (Canada)',
        utc: [
            'America/Glace_Bay',
            'America/Goose_Bay',
            'America/Halifax',
            'America/Moncton',
            'America/Thule',
            'Atlantic/Bermuda'
        ]
    },
    {
        value: 'Central Brazilian Standard Time',
        abbr: 'CBST',
        offset: -4,
        isdst: false,
        text: '(UTC-04:00) Cuiaba',
        utc: ['America/Campo_Grande', 'America/Cuiaba']
    },
    {
        value: 'SA Western Standard Time',
        abbr: 'SWST',
        offset: -4,
        isdst: false,
        text: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
        utc: [
            'America/Anguilla',
            'America/Antigua',
            'America/Aruba',
            'America/Barbados',
            'America/Blanc-Sablon',
            'America/Boa_Vista',
            'America/Curacao',
            'America/Dominica',
            'America/Grand_Turk',
            'America/Grenada',
            'America/Guadeloupe',
            'America/Guyana',
            'America/Kralendijk',
            'America/La_Paz',
            'America/Lower_Princes',
            'America/Manaus',
            'America/Marigot',
            'America/Martinique',
            'America/Montserrat',
            'America/Port_of_Spain',
            'America/Porto_Velho',
            'America/Puerto_Rico',
            'America/Santo_Domingo',
            'America/St_Barthelemy',
            'America/St_Kitts',
            'America/St_Lucia',
            'America/St_Thomas',
            'America/St_Vincent',
            'America/Tortola',
            'Etc/GMT+4'
        ]
    },
    {
        value: 'Pacific SA Standard Time',
        abbr: 'PSST',
        offset: -4,
        isdst: false,
        text: '(UTC-04:00) Santiago',
        utc: ['America/Santiago', 'Antarctica/Palmer']
    },
    {
        value: 'Newfoundland Daylight Time',
        abbr: 'NDT',
        offset: -2.5,
        isdst: true,
        text: '(UTC-03:30) Newfoundland',
        utc: ['America/St_Johns']
    },
    {
        value: 'E. South America Standard Time',
        abbr: 'ESAST',
        offset: -3,
        isdst: false,
        text: '(UTC-03:00) Brasilia',
        utc: ['America/Sao_Paulo']
    },
    {
        value: 'Argentina Standard Time',
        abbr: 'AST',
        offset: -3,
        isdst: false,
        text: '(UTC-03:00) Buenos Aires',
        utc: [
            'America/Argentina/La_Rioja',
            'America/Argentina/Rio_Gallegos',
            'America/Argentina/Salta',
            'America/Argentina/San_Juan',
            'America/Argentina/San_Luis',
            'America/Argentina/Tucuman',
            'America/Argentina/Ushuaia',
            'America/Buenos_Aires',
            'America/Catamarca',
            'America/Cordoba',
            'America/Jujuy',
            'America/Mendoza'
        ]
    },
    {
        value: 'SA Eastern Standard Time',
        abbr: 'SEST',
        offset: -3,
        isdst: false,
        text: '(UTC-03:00) Cayenne, Fortaleza',
        utc: [
            'America/Araguaina',
            'America/Belem',
            'America/Cayenne',
            'America/Fortaleza',
            'America/Maceio',
            'America/Paramaribo',
            'America/Recife',
            'America/Santarem',
            'Antarctica/Rothera',
            'Atlantic/Stanley',
            'Etc/GMT+3'
        ]
    },
    {
        value: 'Greenland Daylight Time',
        abbr: 'GDT',
        offset: -3,
        isdst: true,
        text: '(UTC-03:00) Greenland',
        utc: ['America/Godthab']
    },
    {
        value: 'Montevideo Standard Time',
        abbr: 'MST',
        offset: -3,
        isdst: false,
        text: '(UTC-03:00) Montevideo',
        utc: ['America/Montevideo']
    },
    {
        value: 'Bahia Standard Time',
        abbr: 'BST',
        offset: -3,
        isdst: false,
        text: '(UTC-03:00) Salvador',
        utc: ['America/Bahia']
    },
    {
        value: 'UTC-02',
        abbr: 'U',
        offset: -2,
        isdst: false,
        text: '(UTC-02:00) Coordinated Universal Time-02',
        utc: ['America/Noronha', 'Atlantic/South_Georgia', 'Etc/GMT+2']
    },
    {
        value: 'Mid-Atlantic Daylight Time',
        abbr: 'MDT',
        offset: -1,
        isdst: true,
        text: '(UTC-02:00) Mid-Atlantic - Old',
        utc: []
    },
    {
        value: 'Azores Daylight Time',
        abbr: 'ADT',
        offset: 0,
        isdst: true,
        text: '(UTC-01:00) Azores',
        utc: ['America/Scoresbysund', 'Atlantic/Azores']
    },
    {
        value: 'Cape Verde Standard Time',
        abbr: 'CVST',
        offset: -1,
        isdst: false,
        text: '(UTC-01:00) Cape Verde Is.',
        utc: ['Atlantic/Cape_Verde', 'Etc/GMT+1']
    },
    {
        value: 'Morocco Daylight Time',
        abbr: 'MDT',
        offset: 1,
        isdst: true,
        text: '(UTC) Casablanca',
        utc: ['Africa/Casablanca', 'Africa/El_Aaiun']
    },
    {
        value: 'UTC',
        abbr: 'UTC',
        offset: 0,
        isdst: false,
        text: '(UTC) Coordinated Universal Time',
        utc: ['America/Danmarkshavn', 'Etc/GMT']
    },
    {
        value: 'GMT Standard Time',
        abbr: 'GMT',
        offset: 0,
        isdst: false,
        text: '(UTC) Edinburgh, London',
        utc: ['Europe/Isle_of_Man', 'Europe/Guernsey', 'Europe/Jersey', 'Europe/London']
    },
    {
        value: 'British Summer Time',
        abbr: 'BST',
        offset: 1,
        isdst: true,
        text: '(UTC+01:00) Edinburgh, London',
        utc: ['Europe/Isle_of_Man', 'Europe/Guernsey', 'Europe/Jersey', 'Europe/London']
    },
    {
        value: 'GMT Daylight Time',
        abbr: 'GDT',
        offset: 1,
        isdst: true,
        text: '(UTC) Dublin, Lisbon',
        utc: ['Atlantic/Canary', 'Atlantic/Faeroe', 'Atlantic/Madeira', 'Europe/Dublin', 'Europe/Lisbon']
    },
    {
        value: 'Greenwich Standard Time',
        abbr: 'GST',
        offset: 0,
        isdst: false,
        text: '(UTC) Monrovia, Reykjavik',
        utc: [
            'Africa/Abidjan',
            'Africa/Accra',
            'Africa/Bamako',
            'Africa/Banjul',
            'Africa/Bissau',
            'Africa/Conakry',
            'Africa/Dakar',
            'Africa/Freetown',
            'Africa/Lome',
            'Africa/Monrovia',
            'Africa/Nouakchott',
            'Africa/Ouagadougou',
            'Africa/Sao_Tome',
            'Atlantic/Reykjavik',
            'Atlantic/St_Helena'
        ]
    },
    {
        value: 'W. Europe Daylight Time',
        abbr: 'WEDT',
        offset: 2,
        isdst: true,
        text: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
        utc: [
            'Arctic/Longyearbyen',
            'Europe/Amsterdam',
            'Europe/Andorra',
            'Europe/Berlin',
            'Europe/Busingen',
            'Europe/Gibraltar',
            'Europe/Luxembourg',
            'Europe/Malta',
            'Europe/Monaco',
            'Europe/Oslo',
            'Europe/Rome',
            'Europe/San_Marino',
            'Europe/Stockholm',
            'Europe/Vaduz',
            'Europe/Vatican',
            'Europe/Vienna',
            'Europe/Zurich'
        ]
    },
    {
        value: 'Central Europe Daylight Time',
        abbr: 'CEDT',
        offset: 2,
        isdst: true,
        text: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
        utc: [
            'Europe/Belgrade',
            'Europe/Bratislava',
            'Europe/Budapest',
            'Europe/Ljubljana',
            'Europe/Podgorica',
            'Europe/Prague',
            'Europe/Tirane'
        ]
    },
    {
        value: 'Romance Daylight Time',
        abbr: 'RDT',
        offset: 2,
        isdst: true,
        text: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
        utc: ['Africa/Ceuta', 'Europe/Brussels', 'Europe/Copenhagen', 'Europe/Madrid', 'Europe/Paris']
    },
    {
        value: 'Central European Daylight Time',
        abbr: 'CEDT',
        offset: 2,
        isdst: true,
        text: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
        utc: ['Europe/Sarajevo', 'Europe/Skopje', 'Europe/Warsaw', 'Europe/Zagreb']
    },
    {
        value: 'W. Central Africa Standard Time',
        abbr: 'WCAST',
        offset: 1,
        isdst: false,
        text: '(UTC+01:00) West Central Africa',
        utc: [
            'Africa/Algiers',
            'Africa/Bangui',
            'Africa/Brazzaville',
            'Africa/Douala',
            'Africa/Kinshasa',
            'Africa/Lagos',
            'Africa/Libreville',
            'Africa/Luanda',
            'Africa/Malabo',
            'Africa/Ndjamena',
            'Africa/Niamey',
            'Africa/Porto-Novo',
            'Africa/Tunis',
            'Etc/GMT-1'
        ]
    },
    {
        value: 'Namibia Standard Time',
        abbr: 'NST',
        offset: 1,
        isdst: false,
        text: '(UTC+01:00) Windhoek',
        utc: ['Africa/Windhoek']
    },
    {
        value: 'GTB Daylight Time',
        abbr: 'GDT',
        offset: 3,
        isdst: true,
        text: '(UTC+02:00) Athens, Bucharest',
        utc: ['Asia/Nicosia', 'Europe/Athens', 'Europe/Bucharest', 'Europe/Chisinau']
    },
    {
        value: 'Middle East Daylight Time',
        abbr: 'MEDT',
        offset: 3,
        isdst: true,
        text: '(UTC+02:00) Beirut',
        utc: ['Asia/Beirut']
    },
    {
        value: 'Egypt Standard Time',
        abbr: 'EST',
        offset: 2,
        isdst: false,
        text: '(UTC+02:00) Cairo',
        utc: ['Africa/Cairo']
    },
    {
        value: 'Syria Daylight Time',
        abbr: 'SDT',
        offset: 3,
        isdst: true,
        text: '(UTC+02:00) Damascus',
        utc: ['Asia/Damascus']
    },
    {
        value: 'E. Europe Daylight Time',
        abbr: 'EEDT',
        offset: 3,
        isdst: true,
        text: '(UTC+02:00) E. Europe',
        utc: [
            'Asia/Nicosia',
            'Europe/Athens',
            'Europe/Bucharest',
            'Europe/Chisinau',
            'Europe/Helsinki',
            'Europe/Kiev',
            'Europe/Mariehamn',
            'Europe/Nicosia',
            'Europe/Riga',
            'Europe/Sofia',
            'Europe/Tallinn',
            'Europe/Uzhgorod',
            'Europe/Vilnius',
            'Europe/Zaporozhye'
        ]
    },
    {
        value: 'South Africa Standard Time',
        abbr: 'SAST',
        offset: 2,
        isdst: false,
        text: '(UTC+02:00) Harare, Pretoria',
        utc: [
            'Africa/Blantyre',
            'Africa/Bujumbura',
            'Africa/Gaborone',
            'Africa/Harare',
            'Africa/Johannesburg',
            'Africa/Kigali',
            'Africa/Lubumbashi',
            'Africa/Lusaka',
            'Africa/Maputo',
            'Africa/Maseru',
            'Africa/Mbabane',
            'Etc/GMT-2'
        ]
    },
    {
        value: 'FLE Daylight Time',
        abbr: 'FDT',
        offset: 3,
        isdst: true,
        text: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
        utc: [
            'Europe/Helsinki',
            'Europe/Kiev',
            'Europe/Mariehamn',
            'Europe/Riga',
            'Europe/Sofia',
            'Europe/Tallinn',
            'Europe/Uzhgorod',
            'Europe/Vilnius',
            'Europe/Zaporozhye'
        ]
    },
    {
        value: 'Turkey Standard Time',
        abbr: 'TDT',
        offset: 3,
        isdst: false,
        text: '(UTC+03:00) Istanbul',
        utc: ['Europe/Istanbul']
    },
    {
        value: 'Israel Daylight Time',
        abbr: 'JDT',
        offset: 3,
        isdst: true,
        text: '(UTC+02:00) Jerusalem',
        utc: ['Asia/Jerusalem']
    },
    {
        value: 'Libya Standard Time',
        abbr: 'LST',
        offset: 2,
        isdst: false,
        text: '(UTC+02:00) Tripoli',
        utc: ['Africa/Tripoli']
    },
    {
        value: 'Jordan Standard Time',
        abbr: 'JST',
        offset: 3,
        isdst: false,
        text: '(UTC+03:00) Amman',
        utc: ['Asia/Amman']
    },
    {
        value: 'Arabic Standard Time',
        abbr: 'AST',
        offset: 3,
        isdst: false,
        text: '(UTC+03:00) Baghdad',
        utc: ['Asia/Baghdad']
    },
    {
        value: 'Kaliningrad Standard Time',
        abbr: 'KST',
        offset: 3,
        isdst: false,
        text: '(UTC+02:00) Kaliningrad',
        utc: ['Europe/Kaliningrad']
    },
    {
        value: 'Arab Standard Time',
        abbr: 'AST',
        offset: 3,
        isdst: false,
        text: '(UTC+03:00) Kuwait, Riyadh',
        utc: ['Asia/Aden', 'Asia/Bahrain', 'Asia/Kuwait', 'Asia/Qatar', 'Asia/Riyadh']
    },
    {
        value: 'E. Africa Standard Time',
        abbr: 'EAST',
        offset: 3,
        isdst: false,
        text: '(UTC+03:00) Nairobi',
        utc: [
            'Africa/Addis_Ababa',
            'Africa/Asmera',
            'Africa/Dar_es_Salaam',
            'Africa/Djibouti',
            'Africa/Juba',
            'Africa/Kampala',
            'Africa/Khartoum',
            'Africa/Mogadishu',
            'Africa/Nairobi',
            'Antarctica/Syowa',
            'Etc/GMT-3',
            'Indian/Antananarivo',
            'Indian/Comoro',
            'Indian/Mayotte'
        ]
    },
    {
        value: 'Moscow Standard Time',
        abbr: 'MSK',
        offset: 3,
        isdst: false,
        text: '(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk',
        utc: ['Europe/Kirov', 'Europe/Moscow', 'Europe/Simferopol', 'Europe/Volgograd', 'Europe/Minsk']
    },
    {
        value: 'Samara Time',
        abbr: 'SAMT',
        offset: 4,
        isdst: false,
        text: '(UTC+04:00) Samara, Ulyanovsk, Saratov',
        utc: ['Europe/Astrakhan', 'Europe/Samara', 'Europe/Ulyanovsk']
    },
    {
        value: 'Iran Daylight Time',
        abbr: 'IDT',
        offset: 4.5,
        isdst: true,
        text: '(UTC+03:30) Tehran',
        utc: ['Asia/Tehran']
    },
    {
        value: 'Arabian Standard Time',
        abbr: 'AST',
        offset: 4,
        isdst: false,
        text: '(UTC+04:00) Abu Dhabi, Muscat',
        utc: ['Asia/Dubai', 'Asia/Muscat', 'Etc/GMT-4']
    },
    {
        value: 'Azerbaijan Daylight Time',
        abbr: 'ADT',
        offset: 5,
        isdst: true,
        text: '(UTC+04:00) Baku',
        utc: ['Asia/Baku']
    },
    {
        value: 'Mauritius Standard Time',
        abbr: 'MST',
        offset: 4,
        isdst: false,
        text: '(UTC+04:00) Port Louis',
        utc: ['Indian/Mahe', 'Indian/Mauritius', 'Indian/Reunion']
    },
    {
        value: 'Georgian Standard Time',
        abbr: 'GET',
        offset: 4,
        isdst: false,
        text: '(UTC+04:00) Tbilisi',
        utc: ['Asia/Tbilisi']
    },
    {
        value: 'Caucasus Standard Time',
        abbr: 'CST',
        offset: 4,
        isdst: false,
        text: '(UTC+04:00) Yerevan',
        utc: ['Asia/Yerevan']
    },
    {
        value: 'Afghanistan Standard Time',
        abbr: 'AST',
        offset: 4.5,
        isdst: false,
        text: '(UTC+04:30) Kabul',
        utc: ['Asia/Kabul']
    },
    {
        value: 'West Asia Standard Time',
        abbr: 'WAST',
        offset: 5,
        isdst: false,
        text: '(UTC+05:00) Ashgabat, Tashkent',
        utc: [
            'Antarctica/Mawson',
            'Asia/Aqtau',
            'Asia/Aqtobe',
            'Asia/Ashgabat',
            'Asia/Dushanbe',
            'Asia/Oral',
            'Asia/Samarkand',
            'Asia/Tashkent',
            'Etc/GMT-5',
            'Indian/Kerguelen',
            'Indian/Maldives'
        ]
    },
    {
        value: 'Yekaterinburg Time',
        abbr: 'YEKT',
        offset: 5,
        isdst: false,
        text: '(UTC+05:00) Yekaterinburg',
        utc: ['Asia/Yekaterinburg']
    },
    {
        value: 'Pakistan Standard Time',
        abbr: 'PKT',
        offset: 5,
        isdst: false,
        text: '(UTC+05:00) Islamabad, Karachi',
        utc: ['Asia/Karachi']
    },
    {
        value: 'India Standard Time',
        abbr: 'IST',
        offset: 5.5,
        isdst: false,
        text: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
        utc: ['Asia/Kolkata']
    },
    {
        value: 'Sri Lanka Standard Time',
        abbr: 'SLST',
        offset: 5.5,
        isdst: false,
        text: '(UTC+05:30) Sri Jayawardenepura',
        utc: ['Asia/Colombo']
    },
    {
        value: 'Nepal Standard Time',
        abbr: 'NST',
        offset: 5.75,
        isdst: false,
        text: '(UTC+05:45) Kathmandu',
        utc: ['Asia/Kathmandu']
    },
    {
        value: 'Central Asia Standard Time',
        abbr: 'CAST',
        offset: 6,
        isdst: false,
        text: '(UTC+06:00) Nur-Sultan (Astana)',
        utc: [
            'Antarctica/Vostok',
            'Asia/Almaty',
            'Asia/Bishkek',
            'Asia/Qyzylorda',
            'Asia/Urumqi',
            'Etc/GMT-6',
            'Indian/Chagos'
        ]
    },
    {
        value: 'Bangladesh Standard Time',
        abbr: 'BST',
        offset: 6,
        isdst: false,
        text: '(UTC+06:00) Dhaka',
        utc: ['Asia/Dhaka', 'Asia/Thimphu']
    },
    {
        value: 'Myanmar Standard Time',
        abbr: 'MST',
        offset: 6.5,
        isdst: false,
        text: '(UTC+06:30) Yangon (Rangoon)',
        utc: ['Asia/Rangoon', 'Indian/Cocos']
    },
    {
        value: 'SE Asia Standard Time',
        abbr: 'SAST',
        offset: 7,
        isdst: false,
        text: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
        utc: [
            'Antarctica/Davis',
            'Asia/Bangkok',
            'Asia/Hovd',
            'Asia/Jakarta',
            'Asia/Phnom_Penh',
            'Asia/Pontianak',
            'Asia/Saigon',
            'Asia/Vientiane',
            'Etc/GMT-7',
            'Indian/Christmas'
        ]
    },
    {
        value: 'N. Central Asia Standard Time',
        abbr: 'NCAST',
        offset: 7,
        isdst: false,
        text: '(UTC+07:00) Novosibirsk',
        utc: ['Asia/Novokuznetsk', 'Asia/Novosibirsk', 'Asia/Omsk']
    },
    {
        value: 'China Standard Time',
        abbr: 'CST',
        offset: 8,
        isdst: false,
        text: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
        utc: ['Asia/Hong_Kong', 'Asia/Macau', 'Asia/Shanghai']
    },
    {
        value: 'North Asia Standard Time',
        abbr: 'NAST',
        offset: 8,
        isdst: false,
        text: '(UTC+08:00) Krasnoyarsk',
        utc: ['Asia/Krasnoyarsk']
    },
    {
        value: 'Singapore Standard Time',
        abbr: 'MPST',
        offset: 8,
        isdst: false,
        text: '(UTC+08:00) Kuala Lumpur, Singapore',
        utc: [
            'Asia/Brunei',
            'Asia/Kuala_Lumpur',
            'Asia/Kuching',
            'Asia/Makassar',
            'Asia/Manila',
            'Asia/Singapore',
            'Etc/GMT-8'
        ]
    },
    {
        value: 'W. Australia Standard Time',
        abbr: 'WAST',
        offset: 8,
        isdst: false,
        text: '(UTC+08:00) Perth',
        utc: ['Antarctica/Casey', 'Australia/Perth']
    },
    {
        value: 'Taipei Standard Time',
        abbr: 'TST',
        offset: 8,
        isdst: false,
        text: '(UTC+08:00) Taipei',
        utc: ['Asia/Taipei']
    },
    {
        value: 'Ulaanbaatar Standard Time',
        abbr: 'UST',
        offset: 8,
        isdst: false,
        text: '(UTC+08:00) Ulaanbaatar',
        utc: ['Asia/Choibalsan', 'Asia/Ulaanbaatar']
    },
    {
        value: 'North Asia East Standard Time',
        abbr: 'NAEST',
        offset: 8,
        isdst: false,
        text: '(UTC+08:00) Irkutsk',
        utc: ['Asia/Irkutsk']
    },
    {
        value: 'Japan Standard Time',
        abbr: 'JST',
        offset: 9,
        isdst: false,
        text: '(UTC+09:00) Osaka, Sapporo, Tokyo',
        utc: ['Asia/Dili', 'Asia/Jayapura', 'Asia/Tokyo', 'Etc/GMT-9', 'Pacific/Palau']
    },
    {
        value: 'Korea Standard Time',
        abbr: 'KST',
        offset: 9,
        isdst: false,
        text: '(UTC+09:00) Seoul',
        utc: ['Asia/Pyongyang', 'Asia/Seoul']
    },
    {
        value: 'Cen. Australia Standard Time',
        abbr: 'CAST',
        offset: 9.5,
        isdst: false,
        text: '(UTC+09:30) Adelaide',
        utc: ['Australia/Adelaide', 'Australia/Broken_Hill']
    },
    {
        value: 'AUS Central Standard Time',
        abbr: 'ACST',
        offset: 9.5,
        isdst: false,
        text: '(UTC+09:30) Darwin',
        utc: ['Australia/Darwin']
    },
    {
        value: 'E. Australia Standard Time',
        abbr: 'EAST',
        offset: 10,
        isdst: false,
        text: '(UTC+10:00) Brisbane',
        utc: ['Australia/Brisbane', 'Australia/Lindeman']
    },
    {
        value: 'AUS Eastern Standard Time',
        abbr: 'AEST',
        offset: 10,
        isdst: false,
        text: '(UTC+10:00) Canberra, Melbourne, Sydney',
        utc: ['Australia/Melbourne', 'Australia/Sydney']
    },
    {
        value: 'West Pacific Standard Time',
        abbr: 'WPST',
        offset: 10,
        isdst: false,
        text: '(UTC+10:00) Guam, Port Moresby',
        utc: [
            'Antarctica/DumontDUrville',
            'Etc/GMT-10',
            'Pacific/Guam',
            'Pacific/Port_Moresby',
            'Pacific/Saipan',
            'Pacific/Truk'
        ]
    },
    {
        value: 'Tasmania Standard Time',
        abbr: 'TST',
        offset: 10,
        isdst: false,
        text: '(UTC+10:00) Hobart',
        utc: ['Australia/Currie', 'Australia/Hobart']
    },
    {
        value: 'Yakutsk Standard Time',
        abbr: 'YST',
        offset: 9,
        isdst: false,
        text: '(UTC+09:00) Yakutsk',
        utc: ['Asia/Chita', 'Asia/Khandyga', 'Asia/Yakutsk']
    },
    {
        value: 'Central Pacific Standard Time',
        abbr: 'CPST',
        offset: 11,
        isdst: false,
        text: '(UTC+11:00) Solomon Is., New Caledonia',
        utc: [
            'Antarctica/Macquarie',
            'Etc/GMT-11',
            'Pacific/Efate',
            'Pacific/Guadalcanal',
            'Pacific/Kosrae',
            'Pacific/Noumea',
            'Pacific/Ponape'
        ]
    },
    {
        value: 'Vladivostok Standard Time',
        abbr: 'VST',
        offset: 11,
        isdst: false,
        text: '(UTC+11:00) Vladivostok',
        utc: ['Asia/Sakhalin', 'Asia/Ust-Nera', 'Asia/Vladivostok']
    },
    {
        value: 'New Zealand Standard Time',
        abbr: 'NZST',
        offset: 12,
        isdst: false,
        text: '(UTC+12:00) Auckland, Wellington',
        utc: ['Antarctica/McMurdo', 'Pacific/Auckland']
    },
    {
        value: 'UTC+12',
        abbr: 'U',
        offset: 12,
        isdst: false,
        text: '(UTC+12:00) Coordinated Universal Time+12',
        utc: [
            'Etc/GMT-12',
            'Pacific/Funafuti',
            'Pacific/Kwajalein',
            'Pacific/Majuro',
            'Pacific/Nauru',
            'Pacific/Tarawa',
            'Pacific/Wake',
            'Pacific/Wallis'
        ]
    },
    {
        value: 'Fiji Standard Time',
        abbr: 'FST',
        offset: 12,
        isdst: false,
        text: '(UTC+12:00) Fiji',
        utc: ['Pacific/Fiji']
    },
    {
        value: 'Magadan Standard Time',
        abbr: 'MST',
        offset: 12,
        isdst: false,
        text: '(UTC+12:00) Magadan',
        utc: ['Asia/Anadyr', 'Asia/Kamchatka', 'Asia/Magadan', 'Asia/Srednekolymsk']
    },
    {
        value: 'Kamchatka Daylight Time',
        abbr: 'KDT',
        offset: 13,
        isdst: true,
        text: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
        utc: ['Asia/Kamchatka']
    },
    {
        value: 'Tonga Standard Time',
        abbr: 'TST',
        offset: 13,
        isdst: false,
        text: "(UTC+13:00) Nuku'alofa",
        utc: ['Etc/GMT-13', 'Pacific/Enderbury', 'Pacific/Fakaofo', 'Pacific/Tongatapu']
    },
    {
        value: 'Samoa Standard Time',
        abbr: 'SST',
        offset: 13,
        isdst: false,
        text: '(UTC+13:00) Samoa',
        utc: ['Pacific/Apia']
    }
];
if (false) {
    /** @type {?} */
    TimezoneConstants.abbreviations;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ZoneNamePipe {
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        /** @type {?} */
        const abbr = tz(value).zoneAbbr();
        /** @type {?} */
        const timezones = TimezoneConstants.abbreviations;
        /** @type {?} */
        const timezone = timezones.find((/**
         * @param {?} tz
         * @return {?}
         */
        (tz) => tz.utc.findIndex((/**
         * @param {?} x
         * @return {?}
         */
        (x) => x === value)) !== -1 || tz.abbr === abbr));
        if (!!timezone) {
            return TimezoneConstants.displayValue(timezone.value);
        }
        return tz(value).zoneName();
    }
}
ZoneNamePipe.decorators = [
    { type: Pipe, args: [{
                name: 'ccZoneName'
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PrintableCharsPipe {
    /**
     * @param {?} value
     * @param {?=} config
     * @return {?}
     */
    transform(value, config) {
        /** @type {?} */
        let pattern = /[^ -~]+/gi;
        if (!!config) {
            if (!!config.allowNewLines) {
                pattern = /[^ -~\x0A\x0D]+/gi;
            }
            if (!!config.allowExtended) {
                pattern = /[\x00-\x1F\x7F-\x9F]+/gi;
            }
            if (!!config.allowNewLines && !!config.allowExtended) {
                pattern = /[\x00-\x09\x0B-\x0C\x0E-\x1F\x7F-\x9F]+/gi;
            }
            if (!!config.customPattern) {
                pattern = config.customPattern;
            }
        }
        return value.replace(pattern, '');
    }
}
PrintableCharsPipe.decorators = [
    { type: Pipe, args: [{
                name: 'ccPrintableChars'
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class SafeUrlPipe {
    /**
     * @param {?} sanitizer
     */
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(value);
    }
}
SafeUrlPipe.decorators = [
    { type: Pipe, args: [{
                name: 'ccSafeUrl'
            },] }
];
/** @nocollapse */
SafeUrlPipe.ctorParameters = () => [
    { type: DomSanitizer }
];
if (false) {
    /**
     * @type {?}
     * @private
     */
    SafeUrlPipe.prototype.sanitizer;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class UtcToUserTimezoneDatePipe {
    /**
     * @param {?} value
     * @param {?=} timezone
     * @return {?}
     */
    transform(value, timezone = tz.guess(true)) {
        /** @type {?} */
        const tmp = tz(value, timezone);
        return new Date(tmp.year(), tmp.month(), tmp.date(), tmp.hour(), tmp.minute(), tmp.second(), tmp.millisecond());
    }
}
UtcToUserTimezoneDatePipe.decorators = [
    { type: Pipe, args: [{
                name: 'ccUtcUtzDate'
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PhoneNumberPipe {
    /**
     * @param {?} value
     * @return {?}
     */
    transform(value) {
        if (!!value && value.length > 0) {
            /** @type {?} */
            const number = value.replace(/[()-\s]/gi, '');
            /** @type {?} */
            const first = number.substring(0, 3).padEnd(3, '_');
            /** @type {?} */
            const center = number.substring(3, 6).padEnd(3, '_');
            /** @type {?} */
            const last = number.substring(6).padEnd(4, '_');
            return `(${first}) ${center}-${last}`;
        }
        return value;
    }
}
PhoneNumberPipe.decorators = [
    { type: Pipe, args: [{
                name: 'ccPhoneNumber'
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class PreventCopyPasteDirective {
    /**
     * @param {?} e
     * @return {?}
     */
    preventDrop(e) {
        e.preventDefault();
    }
    /**
     * @param {?} e
     * @return {?}
     */
    preventPaste(e) {
        e.preventDefault();
    }
    /**
     * @param {?} e
     * @return {?}
     */
    preventCopy(e) {
        e.preventDefault();
    }
    /**
     * @param {?} e
     * @return {?}
     */
    preventCut(e) {
        e.preventDefault();
    }
}
PreventCopyPasteDirective.decorators = [
    { type: Directive, args: [{
                selector: '[ccPreventCopyPaste]'
            },] }
];
PreventCopyPasteDirective.propDecorators = {
    preventDrop: [{ type: HostListener, args: ['drop', ['$event'],] }],
    preventPaste: [{ type: HostListener, args: ['paste', ['$event'],] }],
    preventCopy: [{ type: HostListener, args: ['copy', ['$event'],] }],
    preventCut: [{ type: HostListener, args: ['cut', ['$event'],] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class TrimInputDirective {
    /**
     * @param {?} e
     * @return {?}
     */
    handlePaste(e) {
        this.trimInput(e);
    }
    /**
     * @param {?} e
     * @return {?}
     */
    handleKeyup(e) {
        this.trimInput(e);
    }
    /**
     * @private
     * @param {?} e
     * @return {?}
     */
    trimInput(e) {
        /** @type {?} */
        const el = (/** @type {?} */ (e.target));
        /** @type {?} */
        const value = !!el.value ? el.value.trim() : el.value;
        if (el.value !== value) {
            el.value = value;
            /** @type {?} */
            const event = document.createEvent('Event');
            event.initEvent('change', true, true);
            el.dispatchEvent(event);
        }
    }
}
TrimInputDirective.decorators = [
    { type: Directive, args: [{
                selector: '[ccTrimInput]'
            },] }
];
TrimInputDirective.propDecorators = {
    handlePaste: [{ type: HostListener, args: ['paste', ['$event'],] }],
    handleKeyup: [{ type: HostListener, args: ['keyup', ['$event'],] }]
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AddNewRowDirective {
    constructor() {
        this.onAddNewRow = new EventEmitter();
        this.isLastEntry = false;
        this.isNewRowAdded = false;
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onKeyDown(e) {
        /** @type {?} */
        const key = e.event.key;
        if (this.isLastEntry && key.toLowerCase() === 'tab') {
            this.isNewRowAdded = true;
            this.onAddNewRow.emit();
            this.isLastEntry = false;
        }
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onFocusedCellChanged(e) {
        /** @type {?} */
        const gridLastRowIndex = e.component.getVisibleRows().length - 1;
        /** @type {?} */
        const gridLastColumnIndex = e.component.getVisibleColumns().length - 1;
        if (e.columnIndex === gridLastColumnIndex && e.rowIndex === gridLastRowIndex) {
            this.isLastEntry = true;
        }
        else {
            this.isLastEntry = false;
        }
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onCellPrepared(event) {
        if (this.isNewRowAdded && event.rowType === 'data') {
            /** @type {?} */
            const gridLastRowIndex = event.component.getVisibleRows().length - 1;
            /** @type {?} */
            const gridVisibleColumns = event.component.getVisibleColumns();
            /** @type {?} */
            const activeColumnIndex = gridVisibleColumns.findIndex((/**
             * @param {?} d
             * @return {?}
             */
            (d) => d.allowEditing));
            if (event.rowIndex === gridLastRowIndex && event.columnIndex === activeColumnIndex) {
                setTimeout((/**
                 * @return {?}
                 */
                () => {
                    event.component.focus(event.cellElement);
                    this.isNewRowAdded = false;
                }), 200);
            }
        }
    }
}
AddNewRowDirective.decorators = [
    { type: Directive, args: [{
                selector: '[ccAddNewRow]'
            },] }
];
AddNewRowDirective.propDecorators = {
    onAddNewRow: [{ type: Output }],
    onKeyDown: [{ type: HostListener, args: ['onKeyDown', ['$event'],] }],
    onFocusedCellChanged: [{ type: HostListener, args: ['onFocusedCellChanged', ['$event'],] }],
    onCellPrepared: [{ type: HostListener, args: ['onCellPrepared', ['$event'],] }]
};
if (false) {
    /** @type {?} */
    AddNewRowDirective.prototype.onAddNewRow;
    /** @type {?} */
    AddNewRowDirective.prototype.isLastEntry;
    /** @type {?} */
    AddNewRowDirective.prototype.isNewRowAdded;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCCommonModule {
}
CCCommonModule.decorators = [
    { type: NgModule, args: [{
                declarations: [
                    CCCommonComponent,
                    SwitchComponent,
                    ImageEditorComponent,
                    WebCamComponent,
                    MessageBoxComponent,
                    UtcToUserTimezonePipe,
                    SafeHtmlPipe,
                    ZoneNamePipe,
                    PrintableCharsPipe,
                    SafeUrlPipe,
                    PhoneNumberPipe,
                    UtcToUserTimezoneDatePipe,
                    PreventCopyPasteDirective,
                    TrimInputDirective,
                    AddNewRowDirective
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    DxSwitchModule,
                    DxButtonModule,
                    DxFileUploaderModule,
                    DxPopupModule,
                    DxBoxModule,
                    DxToolbarModule,
                    DxNavBarModule,
                    ImageCropperModule,
                    WebcamModule,
                    CCDataGridFeaturesModule
                ],
                exports: [
                    CCCommonComponent,
                    SwitchComponent,
                    ImageEditorComponent,
                    WebCamComponent,
                    MessageBoxComponent,
                    UtcToUserTimezonePipe,
                    SafeHtmlPipe,
                    ZoneNamePipe,
                    PrintableCharsPipe,
                    SafeUrlPipe,
                    PhoneNumberPipe,
                    UtcToUserTimezoneDatePipe,
                    PreventCopyPasteDirective,
                    TrimInputDirective,
                    AddNewRowDirective
                ],
                providers: [UtcToUserTimezoneDatePipe]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCTimeZoneService {
    /**
     * @param {?} timezoneDate
     */
    constructor(timezoneDate) {
        this.timezoneDate = timezoneDate;
    }
    /**
     * @return {?}
     */
    getTimezones() {
        if (!this.timezones || this.timezones.length === 0) {
            this.timezones = tz.names();
        }
        return of(this.timezones);
    }
    /**
     * @return {?}
     */
    getLocalTimezone() {
        return of(tz.guess(true));
    }
    /**
     * @param {?=} myDate
     * @param {?=} timezone
     * @return {?}
     */
    getTimezoneDate(myDate = new Date(), timezone = tz.guess(true)) {
        return this.timezoneDate.transform(myDate, timezone);
    }
}
CCTimeZoneService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CCTimeZoneService.ctorParameters = () => [
    { type: UtcToUserTimezoneDatePipe }
];
/** @nocollapse */ CCTimeZoneService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CCTimeZoneService_Factory() { return new CCTimeZoneService(ɵɵinject(UtcToUserTimezoneDatePipe)); }, token: CCTimeZoneService, providedIn: "root" });
if (false) {
    /**
     * @type {?}
     * @private
     */
    CCTimeZoneService.prototype.timezones;
    /**
     * @type {?}
     * @private
     */
    CCTimeZoneService.prototype.timezoneDate;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class IconConstants {
}
IconConstants.NOTES_AVAILABLE = 'fas fa-clipboard-check';
IconConstants.NOTES_EMPTY = 'far fa-clipboard';
IconConstants.LOG = 'fas fa-list-alt';
IconConstants.ACTION = 'fas fa-running';
IconConstants.REFRESH = 'refresh';
IconConstants.RELOAD = 'fas fa-sync-alt';
IconConstants.ATTACHMENT = 'fas fa-paperclip';
IconConstants.CHECK_MARK = 'fas fa-2x fa-check';
IconConstants.CROSS_MARK = 'fas fa-2x fa-times';
IconConstants.HISTORY = 'fas fa-history';
IconConstants.ADD_NEW = 'plus';
IconConstants.SAVE = 'fas fa-save';
IconConstants.SUBMIT = 'fas fa-upload';
IconConstants.DELETE = 'far fa-trash-alt';
IconConstants.EDIT = 'edit';
IconConstants.EDIT_NEW = 'fas fa-edit';
IconConstants.REVERSE = 'fas fa-redo fa-flip-horizontal';
IconConstants.WRITE_OFF = 'fas fa-money-check-alt';
IconConstants.CHECK = 'fas fa-check';
IconConstants.CROSS = 'fas fa-times';
IconConstants.WARN = 'fas fa-exclamation-triangle';
IconConstants.CLOSE = IconConstants.CROSS;
IconConstants.CANCEL = IconConstants.CROSS;
IconConstants.CONFIRM_YES = IconConstants.CHECK;
IconConstants.CONFIRM_NO = IconConstants.CROSS;
IconConstants.CONFIRM_CANCEL = IconConstants.CROSS;
IconConstants.BACK_TO_LOGIN = 'fas fa-sign-in-alt fa-rotate-180';
IconConstants.RETURN_TO_PREV_PAGE = 'fas fa-arrow-alt-circle-left';
IconConstants.LOGIN = 'fas fa-sign-in-alt';
IconConstants.PROCEED = 'fas fa-arrow-alt-circle-right';
IconConstants.COPY = 'far fa-copy fa-lg';
IconConstants.COPY_REGULAR = 'fas fa-copy';
IconConstants.PASTE = 'fas fa-paste';
IconConstants.SEARCH = 'search';
IconConstants.CLEAR = 'far fa-times-circle';
IconConstants.PRINT = 'fas fa-print';
IconConstants.UPLOAD = 'fas fa-upload';
IconConstants.DOWNLOAD = 'download';
IconConstants.RESET = 'fas fa-retweet';
IconConstants.ADD = 'fas fa-plus';
IconConstants.SHIELD = 'fas fa-shield-alt';
IconConstants.PDF_FILE = 'fas fa-file-pdf cc-icon-pdf';
IconConstants.PDF_FILE_GRID = 'far fa-file-pdf';
IconConstants.LOCK = 'fas fa-lock';
IconConstants.VIEW = 'fas fa-eye';
IconConstants.HIDE = 'fas fa-eye-slash';
IconConstants.KEY = 'fas fa-key';
IconConstants.PLUS = 'far fa-plus-square';
IconConstants.MINUS = 'far fa-minus-square';
IconConstants.DOCS = 'fas fa-file-word cc-icon-docx';
IconConstants.XLSX = 'fas fa-file-excel cc-icon-xlsx';
IconConstants.PPTX = 'fas fa-file-powerpoint cc-icon-pptx';
IconConstants.PNG = 'fas fa-image cc-icon-png';
IconConstants.JPEG = 'fas fa-image cc-icon-jpg';
IconConstants.GIF = 'fas fa-image cc-icon-gif';
IconConstants.TEXT = 'fas fa-file-text cc-icon-text';
IconConstants.INFO = 'fas fa-info-circle';
IconConstants.FLAG = 'fas fa-flag';
IconConstants.HELP = 'fas fa-question-circle';
IconConstants.SETTING = 'fas fa-cog';
IconConstants.FOLDER_OPEN = 'fas fa-folder-open';
IconConstants.EMAIL = 'fas fa-envelope';
IconConstants.EXCHANGE = 'fas fa-exchange-alt';
IconConstants.RANDOM = 'fas fa-random';
IconConstants.RUNNER = 'fas fa-running';
IconConstants.RESTORE = 'fas fa-window-restore';
IconConstants.RESTORE_REGULAR = 'far fa-window-restore';
IconConstants.TASK = 'fas fa-tasks';
IconConstants.CLONE = 'fas fa-clone';
IconConstants.USERSETTING = 'fas fa-users-cog';
IconConstants.EXPIDELOCK = 'fab fa-expeditedssl';
IconConstants.OPENBOX = 'fas fa-box-open';
IconConstants.ELLIPSISH = 'fas fa-ellipsis-h';
IconConstants.ENVELOPE = 'fas fa-envelope';
IconConstants.NOTESLIST = 'fas fa-clipboard-list';
IconConstants.SEND = 'fas fa-paper-plane';
IconConstants.SQUARE_ENVELOPE = 'fas fa-envelope-square';
IconConstants.REPLY = 'fas fa-reply';
IconConstants.REPLY_ALL = 'fas fa-reply-all';
IconConstants.SHARE = 'fas fa-share';
IconConstants.COLUMNS = 'fas fa-columns';
IconConstants.TOOLS = 'fas fa-tools';
IconConstants.SERVER = 'fas fa-server';
IconConstants.ASTERISK = 'fas fa-asterisk';
IconConstants.OPEN_ENVELOPE = 'fas fa-envelope-open';
IconConstants.DOLLAR = 'fas fa-dollar-sign';
IconConstants.BULLHORN = 'fas fa-bullhorn';
IconConstants.BARS = 'fas fa-bars';
IconConstants.FILTER = 'fas fa-filter';
IconConstants.CALENDER = 'fas fa-calendar-plus';
IconConstants.PEN_NIB = 'fas fa-pen-nib';
IconConstants.UNDO = 'fas fa-undo-alt';
IconConstants.CALENDER_CHECK = 'fas fa-calendar-check';
IconConstants.CALENDAR_DAY = 'fas fa-calendar-day';
IconConstants.EXCLAMATORY = 'fas fa-exclamation';
IconConstants.DOUBLE_CHECK = 'fas fa-check-double';
IconConstants.CROSS_CIRCLE = 'fas fa-times-circle';
IconConstants.NEXT = 'fas fa-chevron-right';
IconConstants.PREVIOUS = 'fas fa-chevron-left';
IconConstants.ARROW_DOWN_CIRCLE = 'fas fa-arrow-alt-circle-down';
IconConstants.ARROW_UP_CIRCLE = 'fas fa-arrow-alt-circle-up';
IconConstants.USERTAG = 'fas fa-user-tag';
IconConstants.UNLINK = 'fas fa-unlink';
IconConstants.LINK = 'fas fa-link';
IconConstants.PRODUCTION = 'fas fa-check';
IconConstants.TERMINATE = 'fas fa-minus-circle';
IconConstants.IN_TRANSITION = 'fas fa-shipping-fast';
IconConstants.TRASH_RESTORE = 'fas fa-trash-restore';
IconConstants.MAPMARKER = 'fas fa-map-marker-alt';
IconConstants.CALCULATOR = 'fas fa-calculator';
IconConstants.SHARE_SQUARE = 'fas fa-share-square';
IconConstants.STAR = 'fas fa-star';
IconConstants.FILE = 'fas fa-file';
IconConstants.PEN = 'fas fa-pen';
IconConstants.FOLDER_PLUS = 'fas fa-folder-plus';
IconConstants.HARD_HAT = 'fas fa-hard-hat';
IconConstants.FILE_CONTRACT = 'fas fa-file-contract';
IconConstants.CIRCLE_CHECK = 'fas fa-check-circle';
IconConstants.TAGS = 'fas fa-tags';
IconConstants.INVOICE_DOLLOR = 'fas fa-file-invoice-dollar';
IconConstants.CARET_RIGHT = 'fas fa-caret-right';
IconConstants.EXCLAMATION_CIRCLE = 'fas fa-exclamation-circle';
IconConstants.ARROW_RIGHT = 'fas fa-arrow-right';
IconConstants.ARROW_UP = 'fas fa-arrow-up';
IconConstants.ARROW_DOWN = 'fas fa-arrow-down';
IconConstants.SITE_MAP = 'fas fa-sitemap';
IconConstants.PENCIL = 'fas fa-pencil-alt';
IconConstants.SWATCH_BOOK = 'fas fa-swatchbook';
IconConstants.ROBOT = 'fas fa-robot';
IconConstants.HOME = 'fas fa-home';
if (false) {
    /** @type {?} */
    IconConstants.NOTES_AVAILABLE;
    /** @type {?} */
    IconConstants.NOTES_EMPTY;
    /** @type {?} */
    IconConstants.LOG;
    /** @type {?} */
    IconConstants.ACTION;
    /** @type {?} */
    IconConstants.REFRESH;
    /** @type {?} */
    IconConstants.RELOAD;
    /** @type {?} */
    IconConstants.ATTACHMENT;
    /** @type {?} */
    IconConstants.CHECK_MARK;
    /** @type {?} */
    IconConstants.CROSS_MARK;
    /** @type {?} */
    IconConstants.HISTORY;
    /** @type {?} */
    IconConstants.ADD_NEW;
    /** @type {?} */
    IconConstants.SAVE;
    /** @type {?} */
    IconConstants.SUBMIT;
    /** @type {?} */
    IconConstants.DELETE;
    /** @type {?} */
    IconConstants.EDIT;
    /** @type {?} */
    IconConstants.EDIT_NEW;
    /** @type {?} */
    IconConstants.REVERSE;
    /** @type {?} */
    IconConstants.WRITE_OFF;
    /** @type {?} */
    IconConstants.CHECK;
    /** @type {?} */
    IconConstants.CROSS;
    /** @type {?} */
    IconConstants.WARN;
    /** @type {?} */
    IconConstants.CLOSE;
    /** @type {?} */
    IconConstants.CANCEL;
    /** @type {?} */
    IconConstants.CONFIRM_YES;
    /** @type {?} */
    IconConstants.CONFIRM_NO;
    /** @type {?} */
    IconConstants.CONFIRM_CANCEL;
    /** @type {?} */
    IconConstants.BACK_TO_LOGIN;
    /** @type {?} */
    IconConstants.RETURN_TO_PREV_PAGE;
    /** @type {?} */
    IconConstants.LOGIN;
    /** @type {?} */
    IconConstants.PROCEED;
    /** @type {?} */
    IconConstants.COPY;
    /** @type {?} */
    IconConstants.COPY_REGULAR;
    /** @type {?} */
    IconConstants.PASTE;
    /** @type {?} */
    IconConstants.SEARCH;
    /** @type {?} */
    IconConstants.CLEAR;
    /** @type {?} */
    IconConstants.PRINT;
    /** @type {?} */
    IconConstants.UPLOAD;
    /** @type {?} */
    IconConstants.DOWNLOAD;
    /** @type {?} */
    IconConstants.RESET;
    /** @type {?} */
    IconConstants.ADD;
    /** @type {?} */
    IconConstants.SHIELD;
    /** @type {?} */
    IconConstants.PDF_FILE;
    /** @type {?} */
    IconConstants.PDF_FILE_GRID;
    /** @type {?} */
    IconConstants.LOCK;
    /** @type {?} */
    IconConstants.VIEW;
    /** @type {?} */
    IconConstants.HIDE;
    /** @type {?} */
    IconConstants.KEY;
    /** @type {?} */
    IconConstants.PLUS;
    /** @type {?} */
    IconConstants.MINUS;
    /** @type {?} */
    IconConstants.DOCS;
    /** @type {?} */
    IconConstants.XLSX;
    /** @type {?} */
    IconConstants.PPTX;
    /** @type {?} */
    IconConstants.PNG;
    /** @type {?} */
    IconConstants.JPEG;
    /** @type {?} */
    IconConstants.GIF;
    /** @type {?} */
    IconConstants.TEXT;
    /** @type {?} */
    IconConstants.INFO;
    /** @type {?} */
    IconConstants.FLAG;
    /** @type {?} */
    IconConstants.HELP;
    /** @type {?} */
    IconConstants.SETTING;
    /** @type {?} */
    IconConstants.FOLDER_OPEN;
    /** @type {?} */
    IconConstants.EMAIL;
    /** @type {?} */
    IconConstants.EXCHANGE;
    /** @type {?} */
    IconConstants.RANDOM;
    /** @type {?} */
    IconConstants.RUNNER;
    /** @type {?} */
    IconConstants.RESTORE;
    /** @type {?} */
    IconConstants.RESTORE_REGULAR;
    /** @type {?} */
    IconConstants.TASK;
    /** @type {?} */
    IconConstants.CLONE;
    /** @type {?} */
    IconConstants.USERSETTING;
    /** @type {?} */
    IconConstants.EXPIDELOCK;
    /** @type {?} */
    IconConstants.OPENBOX;
    /** @type {?} */
    IconConstants.ELLIPSISH;
    /** @type {?} */
    IconConstants.ENVELOPE;
    /** @type {?} */
    IconConstants.NOTESLIST;
    /** @type {?} */
    IconConstants.SEND;
    /** @type {?} */
    IconConstants.SQUARE_ENVELOPE;
    /** @type {?} */
    IconConstants.REPLY;
    /** @type {?} */
    IconConstants.REPLY_ALL;
    /** @type {?} */
    IconConstants.SHARE;
    /** @type {?} */
    IconConstants.COLUMNS;
    /** @type {?} */
    IconConstants.TOOLS;
    /** @type {?} */
    IconConstants.SERVER;
    /** @type {?} */
    IconConstants.ASTERISK;
    /** @type {?} */
    IconConstants.OPEN_ENVELOPE;
    /** @type {?} */
    IconConstants.DOLLAR;
    /** @type {?} */
    IconConstants.BULLHORN;
    /** @type {?} */
    IconConstants.BARS;
    /** @type {?} */
    IconConstants.FILTER;
    /** @type {?} */
    IconConstants.CALENDER;
    /** @type {?} */
    IconConstants.PEN_NIB;
    /** @type {?} */
    IconConstants.UNDO;
    /** @type {?} */
    IconConstants.CALENDER_CHECK;
    /** @type {?} */
    IconConstants.CALENDAR_DAY;
    /** @type {?} */
    IconConstants.EXCLAMATORY;
    /** @type {?} */
    IconConstants.DOUBLE_CHECK;
    /** @type {?} */
    IconConstants.CROSS_CIRCLE;
    /** @type {?} */
    IconConstants.NEXT;
    /** @type {?} */
    IconConstants.PREVIOUS;
    /** @type {?} */
    IconConstants.ARROW_DOWN_CIRCLE;
    /** @type {?} */
    IconConstants.ARROW_UP_CIRCLE;
    /** @type {?} */
    IconConstants.USERTAG;
    /** @type {?} */
    IconConstants.UNLINK;
    /** @type {?} */
    IconConstants.LINK;
    /** @type {?} */
    IconConstants.PRODUCTION;
    /** @type {?} */
    IconConstants.TERMINATE;
    /** @type {?} */
    IconConstants.IN_TRANSITION;
    /** @type {?} */
    IconConstants.TRASH_RESTORE;
    /** @type {?} */
    IconConstants.MAPMARKER;
    /** @type {?} */
    IconConstants.CALCULATOR;
    /** @type {?} */
    IconConstants.SHARE_SQUARE;
    /** @type {?} */
    IconConstants.STAR;
    /** @type {?} */
    IconConstants.FILE;
    /** @type {?} */
    IconConstants.PEN;
    /** @type {?} */
    IconConstants.FOLDER_PLUS;
    /** @type {?} */
    IconConstants.HARD_HAT;
    /** @type {?} */
    IconConstants.FILE_CONTRACT;
    /** @type {?} */
    IconConstants.CIRCLE_CHECK;
    /** @type {?} */
    IconConstants.TAGS;
    /** @type {?} */
    IconConstants.INVOICE_DOLLOR;
    /** @type {?} */
    IconConstants.CARET_RIGHT;
    /** @type {?} */
    IconConstants.EXCLAMATION_CIRCLE;
    /** @type {?} */
    IconConstants.ARROW_RIGHT;
    /** @type {?} */
    IconConstants.ARROW_UP;
    /** @type {?} */
    IconConstants.ARROW_DOWN;
    /** @type {?} */
    IconConstants.SITE_MAP;
    /** @type {?} */
    IconConstants.PENCIL;
    /** @type {?} */
    IconConstants.SWATCH_BOOK;
    /** @type {?} */
    IconConstants.ROBOT;
    /** @type {?} */
    IconConstants.HOME;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCSessionManagerService {
    constructor() {
        this.defaultSessionTimeout = 1000 * 60 * 60; // 1 hour
        // 1 hour
        this.defaultWarningTimeout = 1000 * 30; // 30 Secs
        this._message = "Your session is about to expire in <strong>{0}</strong> sec(s). <br />Click on 'Continue' to extend it";
    }
    /**
     * @param {?=} sessionTimeout
     * @param {?=} warningTimeout
     * @return {?}
     */
    activate(sessionTimeout, warningTimeout) {
        this._sessionTimeout = sessionTimeout || this._sessionTimeout || this.defaultSessionTimeout;
        this._warningTimeout = warningTimeout || this._warningTimeout || this.defaultWarningTimeout;
        /** @type {?} */
        const timeout = this._sessionTimeout - this._warningTimeout;
        this._timerId = setTimeout((/**
         * @return {?}
         */
        () => this.displayWarning()), timeout);
        this._isActivated = true;
    }
    /**
     * @return {?}
     */
    deactivate() {
        clearTimeout(this._timerId);
        clearInterval(this._intervalId);
        this._sessionTimeout = null;
        this._warningTimeout = null;
        this._isActivated = false;
    }
    /**
     * @param {?=} sessionTimeout
     * @param {?=} warningTimeout
     * @return {?}
     */
    reset(sessionTimeout, warningTimeout) {
        if (this._isActivated) {
            clearTimeout(this._timerId);
            clearInterval(this._intervalId);
            this.activate(sessionTimeout, warningTimeout);
        }
    }
    /**
     * @return {?}
     */
    displayWarning() {
        /** @type {?} */
        const timeout = this._warningTimeout / 1000;
        /** @type {?} */
        const messageHtml = `<div id="warnEl" style="text-align:center">${this._message.replace('{0}', timeout.toString())}</div>`;
        /** @type {?} */
        const dialog = custom({
            title: 'Session Timeout',
            messageHtml,
            buttons: [
                {
                    text: 'Continue',
                    type: 'success',
                    icon: IconConstants.CONFIRM_YES,
                    onClick: (/**
                     * @param {?} e
                     * @return {?}
                     */
                    (e) => {
                        return true;
                    })
                }
            ]
        });
        dialog.show().then((/**
         * @return {?}
         */
        () => this.reset(this._sessionTimeout, this._warningTimeout)));
        this.countDownWarning(dialog);
    }
    /**
     * @param {?} dialog
     * @return {?}
     */
    countDownWarning(dialog) {
        /** @type {?} */
        let offset = this._warningTimeout;
        this._intervalId = setInterval((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const el = document.getElementById('warnEl');
            if (offset > 0) {
                offset -= 1000;
                /** @type {?} */
                const timeout = offset / 1000;
                el.innerHTML = this._message.replace('{0}', timeout.toString());
            }
            else {
                dialog.hide();
                this.clearSession();
            }
        }), 1000);
    }
    /**
     * @return {?}
     */
    clearSession() {
        clearTimeout(this._timerId);
        clearInterval(this._intervalId);
        if (!!this.logoutHandler) {
            this.logoutHandler();
            this._isActivated = false;
        }
        custom({
            title: 'Session Timeout',
            messageHtml: `Your session expired. You need to login again`,
            buttons: [
                {
                    text: 'OK',
                    type: 'success'
                }
            ]
        }).show();
    }
}
CCSessionManagerService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ CCSessionManagerService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CCSessionManagerService_Factory() { return new CCSessionManagerService(); }, token: CCSessionManagerService, providedIn: "root" });
if (false) {
    /** @type {?} */
    CCSessionManagerService.prototype.logoutHandler;
    /** @type {?} */
    CCSessionManagerService.prototype.defaultSessionTimeout;
    /** @type {?} */
    CCSessionManagerService.prototype.defaultWarningTimeout;
    /**
     * @type {?}
     * @private
     */
    CCSessionManagerService.prototype._sessionTimeout;
    /**
     * @type {?}
     * @private
     */
    CCSessionManagerService.prototype._warningTimeout;
    /**
     * @type {?}
     * @private
     */
    CCSessionManagerService.prototype._timerId;
    /**
     * @type {?}
     * @private
     */
    CCSessionManagerService.prototype._intervalId;
    /**
     * @type {?}
     * @private
     */
    CCSessionManagerService.prototype._isActivated;
    /**
     * @type {?}
     * @private
     */
    CCSessionManagerService.prototype._message;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * @record
 */
function ITokenEntry() { }
if (false) {
    /** @type {?} */
    ITokenEntry.prototype.storageKey;
    /** @type {?} */
    ITokenEntry.prototype.token;
    /** @type {?} */
    ITokenEntry.prototype.timerId;
}
class CCTokenRenewalService {
    /**
     * @param {?} httpClient
     */
    constructor(httpClient) {
        this.httpClient = httpClient;
        this._jwtHelper = new JwtHelperService();
        this._registeredKeys = new Map();
    }
    /**
     * @param {?} storageKey
     * @return {?}
     */
    registerToken(storageKey) {
        if (!!this.tokenRenewApi) {
            /** @type {?} */
            const entry = {
                storageKey,
                token: null,
                timerId: null
            };
            this.unregisterToken(storageKey);
            this._registeredKeys.set(storageKey, entry);
        }
        else {
            console.error('Please set tokenRenewApi for CCTokenManagerService');
        }
    }
    /**
     * @param {?} storageKey
     * @return {?}
     */
    unregisterToken(storageKey) {
        if (!!this.tokenRenewApi) {
            /** @type {?} */
            const entry = this._registeredKeys.get(storageKey);
            if (!!entry) {
                clearTimeout(entry.timerId);
            }
            this._registeredKeys.delete(storageKey);
        }
        else {
            console.error('Please set tokenRenewApi for CCTokenManagerService');
        }
    }
    /**
     * @return {?}
     */
    clearAll() {
        this._registeredKeys.clear();
    }
    /**
     * @return {?}
     */
    activate() {
        this._isActivated = true;
        this.monitor();
    }
    /**
     * @return {?}
     */
    deactivate() {
        this._isActivated = false;
        clearInterval(this._intervalId);
    }
    /**
     * @private
     * @return {?}
     */
    monitor() {
        if (this._isActivated) {
            clearInterval(this._intervalId);
            this._intervalId = setInterval((/**
             * @return {?}
             */
            () => {
                this._registeredKeys.forEach((/**
                 * @param {?} entry
                 * @param {?} key
                 * @return {?}
                 */
                (entry, key) => {
                    /** @type {?} */
                    const token = localStorage.getItem(key);
                    if (!!token && !!token.length && (!entry.timerId || entry.token !== token)) {
                        entry.token = token;
                        this.process(entry);
                    }
                    else if (!token || !token.length) {
                        clearTimeout(entry.timerId);
                        entry.timerId = null;
                        entry.token = null;
                    }
                }));
            }), 10000);
        }
    }
    /**
     * @private
     * @param {?} entry
     * @return {?}
     */
    process(entry) {
        /** @type {?} */
        const expiresAt = this._jwtHelper.getTokenExpirationDate(entry.token);
        /** @type {?} */
        const timeout = expiresAt.getTime() - Date.now() - 60000;
        if (timeout > 0) {
            clearTimeout(entry.timerId);
            entry.timerId = setTimeout((/**
             * @return {?}
             */
            () => {
                this.renewToken(entry.token).subscribe((/**
                 * @param {?} renewedToken
                 * @return {?}
                 */
                (renewedToken) => {
                    localStorage.setItem(entry.storageKey, renewedToken);
                    // Do the process recursively
                    entry.token = renewedToken;
                    this.process(entry);
                }));
            }), timeout);
        }
        else {
            console.error("Can't renew already expired token!");
        }
    }
    /**
     * @private
     * @param {?} token
     * @return {?}
     */
    renewToken(token) {
        /** @type {?} */
        const headers = new HttpHeaders({ Authorization: `Bearer ${token}` });
        return this.httpClient
            .post(this.tokenRenewApi, {}, { headers })
            .pipe(map((/**
         * @param {?} response
         * @return {?}
         */
        (response) => response.token.toString())));
    }
}
CCTokenRenewalService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */
CCTokenRenewalService.ctorParameters = () => [
    { type: HttpClient }
];
/** @nocollapse */ CCTokenRenewalService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CCTokenRenewalService_Factory() { return new CCTokenRenewalService(ɵɵinject(HttpClient)); }, token: CCTokenRenewalService, providedIn: "root" });
if (false) {
    /** @type {?} */
    CCTokenRenewalService.prototype.tokenRenewApi;
    /**
     * @type {?}
     * @private
     */
    CCTokenRenewalService.prototype._registeredKeys;
    /**
     * @type {?}
     * @private
     */
    CCTokenRenewalService.prototype._jwtHelper;
    /**
     * @type {?}
     * @private
     */
    CCTokenRenewalService.prototype._intervalId;
    /**
     * @type {?}
     * @private
     */
    CCTokenRenewalService.prototype._isActivated;
    /**
     * @type {?}
     * @private
     */
    CCTokenRenewalService.prototype.httpClient;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CCPasswordHelperService {
    /**
     * @param {?} keyCode
     * @return {?}
     */
    isControlCharater(keyCode) {
        // Backspace, Delete, Tab, Escape, Enter, Shift, End, Home, left, right, delete ...
        /** @type {?} */
        const arr = [8, 9, 13, 16, 17, 18, 19, 20, 27, 33, 32, 34, 35, 36, 37, 38, 39, 40, 44, 45, 46];
        return arr.indexOf(keyCode) > -1;
    }
    /**
     * @param {?} password
     * @return {?}
     */
    getPasswordStrength(password) {
        /** @type {?} */
        let result = 0;
        if (!!password && password.length > 0) {
            if (this.hasLowerCase(password)) {
                result++;
            }
            if (this.hasUpperCase(password)) {
                result++;
            }
            if (this.hasNumeric(password)) {
                result++;
            }
            if (this.hasSpecialCharacter(password)) {
                result++;
            }
            else if (result > 2) {
                result--;
            }
        }
        return result;
    }
    /**
     * @param {?} password
     * @return {?}
     */
    hasValidCharacters(password) {
        if (!!password && password.length > 0) {
            if (this.hasLowerCase(password) === false) {
                return false;
            }
            else if (this.hasUpperCase(password) === false) {
                return false;
            }
            else if (this.hasNumeric(password) === false) {
                return false;
            }
            else if (this.hasSpecialCharacter(password) === false) {
                return false;
            }
            return true;
        }
        return false;
    }
    /**
     * @param {?} password
     * @return {?}
     */
    hasLowerCase(password) {
        return /(?=.*[a-z])/.test(password);
    }
    /**
     * @param {?} password
     * @return {?}
     */
    hasUpperCase(password) {
        return /(?=.*[A-Z])/.test(password);
    }
    /**
     * @param {?} password
     * @return {?}
     */
    hasNumeric(password) {
        return /(?=.*\d)/.test(password);
    }
    /**
     * @param {?} password
     * @return {?}
     */
    hasSpecialCharacter(password) {
        return /(?=.*[!@#\$%\^&\*-\+(),./:<=>?\[\\\]_{|}~])/.test(password);
    }
}
CCPasswordHelperService.decorators = [
    { type: Injectable, args: [{
                providedIn: 'root'
            },] }
];
/** @nocollapse */ CCPasswordHelperService.ngInjectableDef = ɵɵdefineInjectable({ factory: function CCPasswordHelperService_Factory() { return new CCPasswordHelperService(); }, token: CCPasswordHelperService, providedIn: "root" });

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CalculatorComponent {
    constructor() {
        this.inputValue = '0';
        this.validKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '+', '-', '*', '/', '.', '%'];
    }
    /**
     * @return {?}
     */
    onClear() {
        if (this.inputValue != '0') {
            this.inputValue = this.inputValue.substring(0, this.inputValue.length - 1);
        }
    }
    /**
     * @return {?}
     */
    onAllClear() {
        this.inputValue = '0';
    }
    /**
     * @param {?} num
     * @return {?}
     */
    onNumClick(num) {
        if (num == '.') {
            if (this.inputValue != '0') {
                /** @type {?} */
                const lastNum = this.getLastOperand();
                if (lastNum.lastIndexOf('.') >= 0) {
                    return;
                }
            }
        }
        // Do Not Allow 0 at beginning.
        if (num == '0') {
            if (this.inputValue == '0') {
                return;
            }
            /** @type {?} */
            const PrevKey = this.inputValue[this.inputValue.length - 1];
            if (PrevKey === '/' || PrevKey === '*' || PrevKey === '-' || PrevKey === '+' || PrevKey === '%') {
                return;
            }
        }
        this.inputValue = this.inputValue == '0' ? num : this.inputValue + num;
        this.calcAnswer();
    }
    /**
     * @return {?}
     */
    getLastOperand() {
        /** @type {?} */
        let pos;
        pos = this.inputValue.lastIndexOf('+');
        if (this.inputValue.lastIndexOf('-') > pos) {
            pos = this.inputValue.lastIndexOf('-');
        }
        if (this.inputValue.lastIndexOf('*') > pos) {
            pos = this.inputValue.lastIndexOf('*');
        }
        if (this.inputValue.lastIndexOf('/') > pos) {
            pos = this.inputValue.lastIndexOf('/');
        }
        if (this.inputValue.lastIndexOf('%') > pos) {
            pos = this.inputValue.lastIndexOf('%');
        }
        return this.inputValue.substr(pos + 1);
    }
    /**
     * @param {?} operator
     * @return {?}
     */
    onOperatorClick(operator) {
        /** @type {?} */
        const lastKey = this.inputValue[this.inputValue.length - 1];
        if (lastKey === '/' || lastKey === '*' || lastKey === '-' || lastKey === '+' || lastKey === '%') {
            return;
        }
        this.inputValue = this.inputValue + operator;
        this.calcAnswer();
    }
    /**
     * @return {?}
     */
    calcAnswer() {
        /** @type {?} */
        let formula = this.inputValue;
        /** @type {?} */
        let lastKey = formula[formula.length - 1];
        if (lastKey === '.') {
            formula = formula.substring(0, formula.length - 1);
        }
        lastKey = formula[formula.length - 1];
        // We only support '-', '+', '*', '/', '%' characters for calculation
        if (lastKey === '/' ||
            lastKey === '*' ||
            lastKey === '-' ||
            lastKey === '+' ||
            lastKey === '%' ||
            lastKey === '.') {
            formula = formula.substring(0, formula.length - 1);
        }
        /** @type {?} */
        const characters = formula.split('');
        /** @type {?} */
        const isValidChar = characters.filter((/**
         * @param {?} c
         * @return {?}
         */
        (c) => this.validKeys.includes(c))).length === characters.length;
        if (isValidChar) {
            this.totalValue = eval(formula);
        }
    }
    /**
     * @return {?}
     */
    getAnswer() {
        this.calcAnswer();
        this.inputValue = this.totalValue;
        if (this.inputValue == '0') {
            this.inputValue = '';
        }
    }
    /**
     * @param {?} token
     * @return {?}
     */
    isOperator(token) {
        return token === '-' || token === '+' || token === '*' || token === '/' || token === '%';
    }
    // KEYBOARD SUPPORT
    /**
     * @param {?} event
     * @return {?}
     */
    onKeyDown(event) {
        /** @type {?} */
        const key = event.key.toLowerCase();
        event.preventDefault();
        if (key === 'c' || key === 'backspace') {
            this.onClear();
        }
        else if (key === ',' || key === '.') {
            this.onNumClick('.');
        }
        else if (!isNaN(parseInt(key))) {
            this.onNumClick(key);
        }
        else if (key === 'enter') {
            this.getAnswer();
        }
        else if (this.isOperator(key)) {
            this.onOperatorClick(key);
        }
    }
}
CalculatorComponent.decorators = [
    { type: Component, args: [{
                selector: 'cc-calculator',
                template: "<div class=\"calculator property-radio-group\">\n    <dx-text-box class=\"calculator-screen\" [disabled]=\"true\" [(value)]=\"inputValue\"></dx-text-box>\n\n    <div class=\"calculator-keys\">\n        <dx-button class=\"all-clear\" (onClick)=\"onClear()\">C</dx-button>\n        <dx-button class=\"all-clear\" (onClick)=\"onAllClear()\">AC</dx-button>\n        <dx-button class=\"operator cal-btn\" (onClick)=\"onOperatorClick('%')\">%</dx-button>\n        <dx-button class=\"operator cal-btn\" (onClick)=\"onOperatorClick('/')\">/</dx-button>\n\n        <dx-button class=\"cal-btn\" (onClick)=\"onNumClick('7')\">7</dx-button>\n        <dx-button class=\"cal-btn\" (onClick)=\"onNumClick('8')\">8</dx-button>\n        <dx-button class=\"cal-btn\" (onClick)=\"onNumClick('9')\">9</dx-button>\n        <dx-button class=\"operator cal-btn\" (onClick)=\"onOperatorClick('*')\">*</dx-button>\n\n        <dx-button class=\"cal-btn\" (onClick)=\"onNumClick('4')\">4</dx-button>\n        <dx-button class=\"cal-btn\" (onClick)=\"onNumClick('5')\">5</dx-button>\n        <dx-button class=\"cal-btn\" (onClick)=\"onNumClick('6')\">6</dx-button>\n        <dx-button class=\"operator cal-btn\" (onClick)=\"onOperatorClick('-')\">-</dx-button>\n\n        <dx-button class=\"cal-btn\" (onClick)=\"onNumClick('1')\">1</dx-button>\n        <dx-button class=\"cal-btn\" (onClick)=\"onNumClick('2')\">2</dx-button>\n        <dx-button class=\"cal-btn\" (onClick)=\"onNumClick('3')\">3</dx-button>\n        <dx-button class=\"operator cal-btn\" (onClick)=\"onOperatorClick('+')\">+</dx-button>\n\n        <dx-button class=\"cal-btn\" (onClick)=\"onNumClick('0')\">0</dx-button>\n        <dx-button class=\"decimal\" (onClick)=\"onNumClick('.')\">.</dx-button>\n        <dx-button class=\"equal-sign\" (onClick)=\"getAnswer()\">=</dx-button>\n    </div>\n</div>\n",
                styles: [":host{height:100%;width:100%}.calculator{border-radius:5px;width:100%}.calculator-screen{width:100%;font-size:1.5rem;height:50px;padding-right:20px;padding-left:10px}.calculator-screen ::ng-deep .dx-texteditor-input{text-align:right!important}.cal-btn{height:40px;border-radius:3px;background-color:transparent;font-size:1.2rem}.equal-sign{height:100%;grid-area:5/4/5/2}.calculator-keys{display:grid;grid-template-columns:repeat(4,1fr);grid-gap:20px;padding:20px}"]
            }] }
];
CalculatorComponent.propDecorators = {
    onKeyDown: [{ type: HostListener, args: ['window:keydown', ['$event'],] }]
};
if (false) {
    /** @type {?} */
    CalculatorComponent.prototype.inputValue;
    /** @type {?} */
    CalculatorComponent.prototype.totalValue;
    /** @type {?} */
    CalculatorComponent.prototype.validKeys;
}
class CCCalculatorModule {
}
CCCalculatorModule.decorators = [
    { type: NgModule, args: [{
                declarations: [CalculatorComponent],
                imports: [CommonModule, DxButtonModule, DxTextBoxModule],
                exports: [CalculatorComponent]
            },] }
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class AuthConstants {
}
AuthConstants.passwordSpecialCharactersAllowed = [
    '!',
    '@',
    '#',
    '$',
    '%',
    '^',
    '&',
    '*',
    '-',
    '+',
    '(',
    ')',
    ',',
    '.',
    '/',
    ':',
    '<',
    '=',
    '>',
    '?',
    '[',
    '\\',
    ']',
    '_',
    '{',
    '|',
    '}',
    '~'
];
if (false) {
    /** @type {?} */
    AuthConstants.passwordSpecialCharactersAllowed;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class CalendarExportContants {
    /**
     * @param {?} prodid
     * @return {?}
     */
    static PRODID(prodid) {
        return `PRODID:${prodid}`;
    }
    /**
     * @param {?} uid
     * @return {?}
     */
    static UID(uid) {
        return `UID:${uid}`;
    }
    /**
     * @param {?} summary
     * @return {?}
     */
    static SUMMARY(summary) {
        return `SUMMARY:${summary}`;
    }
    /**
     * @param {?} date
     * @param {?=} tzone
     * @return {?}
     */
    static DTSTAMP(date, tzone = 'Etc/UTC') {
        return !!date ? `DTSTAMP;TZID=${tzone}:${date}` : ``;
    }
    /**
     * @param {?} date
     * @param {?=} tzone
     * @return {?}
     */
    static DTSTART(date, tzone = 'Etc/UTC') {
        return !!date ? `DTSTART;TZID=${tzone}:${date}` : ``;
    }
    /**
     * @param {?} date
     * @param {?=} tzone
     * @return {?}
     */
    static DTEND(date, tzone = 'Etc/UTC') {
        return !!date ? `DTEND;TZID=${tzone}:${date}` : ``;
    }
    /**
     * @param {?} description
     * @return {?}
     */
    static DESCRIPTION(description) {
        return `DESCRIPTION:${description}`;
    }
    /**
     * @param {?} status
     * @return {?}
     */
    static STATUS(status) {
        return `X-MICROSOFT-CDO-BUSYSTATUS:${status}`;
    }
    /**
     * @param {?} rrule
     * @return {?}
     */
    static RRULE(rrule) {
        return !!rrule ? `RRULE:${rrule}` : ``;
    }
    /**
     * @param {?} exdate
     * @return {?}
     */
    static EXDATE(exdate) {
        return !!exdate ? `EXDATE:${exdate}` : ``;
    }
    /**
     * @param {?} organizer
     * @return {?}
     */
    static ORGANIZER(organizer) {
        /** @type {?} */
        let result = `ORGANIZER:${organizer.name}`;
        if (!!organizer.email) {
            result += `:mailto:${organizer.email}`;
        }
        return result;
    }
}
CalendarExportContants.FORMAT_STRING = 'YYYYMMDDTHHmmss';
CalendarExportContants.BEGIN_VCAL = 'BEGIN:VCALENDAR';
CalendarExportContants.END_VCAL = 'END:VCALENDAR';
CalendarExportContants.VERSION = 'VERSION:2.0';
CalendarExportContants.CALSCALE = 'CALSCALE:GREGORIAN';
CalendarExportContants.METHOD = 'METHOD:PUBLISH';
CalendarExportContants.PUBLISHED = 'X-PUBLISHED-TTL:PT1H';
CalendarExportContants.BEGIN_EVENT = 'BEGIN:VEVENT';
CalendarExportContants.END_EVENT = 'END:VEVENT';
CalendarExportContants.FILE_URL = 'data:text/calendar;charset=utf8,';
CalendarExportContants.NEW_LINE = '\n';
if (false) {
    /** @type {?} */
    CalendarExportContants.FORMAT_STRING;
    /** @type {?} */
    CalendarExportContants.BEGIN_VCAL;
    /** @type {?} */
    CalendarExportContants.END_VCAL;
    /** @type {?} */
    CalendarExportContants.VERSION;
    /** @type {?} */
    CalendarExportContants.CALSCALE;
    /** @type {?} */
    CalendarExportContants.METHOD;
    /** @type {?} */
    CalendarExportContants.PUBLISHED;
    /** @type {?} */
    CalendarExportContants.BEGIN_EVENT;
    /** @type {?} */
    CalendarExportContants.END_EVENT;
    /** @type {?} */
    CalendarExportContants.FILE_URL;
    /** @type {?} */
    CalendarExportContants.NEW_LINE;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const APP_VERSION = 'v25.5.1.2';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
const moment = moment$1;
class DateUtils {
    /**
     * @return {?}
     */
    static getUTCDate() {
        return moment().utc().toDate();
    }
    /**
     * @param {?} date
     * @param {?} numDays
     * @return {?}
     */
    static addDays(date, numDays) {
        return moment(date).add(numDays, 'days').toDate();
    }
    /**
     * @param {?} date
     * @param {?} numMonths
     * @return {?}
     */
    static addMonths(date, numMonths) {
        return moment(date).add(numMonths, 'months').toDate();
    }
    /**
     * @param {?} date
     * @param {?} numYears
     * @return {?}
     */
    static addYears(date, numYears) {
        return moment(date).add(numYears, 'years').toDate();
    }
    /**
     * @param {?} date
     * @param {?} numDays
     * @return {?}
     */
    static removeDays(date, numDays) {
        return moment(date)
            .add(-1 * numDays, 'days')
            .toDate();
    }
    /**
     * @param {?} date
     * @param {?} numMonths
     * @return {?}
     */
    static removeMonths(date, numMonths) {
        return moment(date)
            .add(-1 * numMonths, 'months')
            .toDate();
    }
    /**
     * @param {?} date
     * @param {?} numYears
     * @return {?}
     */
    static removeYears(date, numYears) {
        return moment(date)
            .add(-1 * numYears, 'years')
            .toDate();
    }
    /**
     * @param {?} date
     * @return {?}
     */
    static firstDayOfMonth(date) {
        return moment(date).startOf('month').toDate();
    }
    /**
     * @param {?} date
     * @param {?} numMonths
     * @return {?}
     */
    static firstDayOfNextMonth(date, numMonths) {
        return moment(date)
            .startOf('month')
            .add(1 * numMonths, 'months')
            .toDate();
    }
    /**
     * @param {?} date
     * @return {?}
     */
    static lastDayOfMonth(date) {
        return moment(date).endOf('month').toDate();
    }
    /**
     * @param {?} date
     * @return {?}
     */
    static firstDayOfYear(date) {
        return moment(date).startOf('year').toDate();
    }
    /**
     * @param {?} date
     * @param {?} numYears
     * @return {?}
     */
    static firstDayOfNextYear(date, numYears) {
        return moment(date)
            .startOf('year')
            .add(1 * numYears, 'years')
            .toDate();
    }
    /**
     * @param {?} date
     * @return {?}
     */
    static lastDayOfYear(date) {
        return moment(date).endOf('year').toDate();
    }
    /**
     * @param {?} date
     * @param {?} format
     * @return {?}
     */
    static dateToString(date, format) {
        return moment(date).format(format);
    }
    /**
     * @param {?} value
     * @param {?} format
     * @return {?}
     */
    static stringToDate(value, format) {
        return moment(value, format).toDate();
    }
    /**
     * @param {?} date1
     * @param {?} date2
     * @return {?}
     */
    static differenceInDays(date1, date2) {
        return moment(date2).diff(moment(date1), 'days');
    }
    /**
     * @param {?} date1
     * @param {?} date2
     * @return {?}
     */
    static differenceInMonths(date1, date2) {
        return moment(date2).diff(moment(date1), 'months');
    }
    /**
     * @param {?} date
     * @return {?}
     */
    static startOfDay(date) {
        return moment(date).startOf('day').toDate();
    }
    /**
     * @param {?} date
     * @return {?}
     */
    static endOfDay(date) {
        return moment(date).endOf('day').toDate();
    }
    /**
     * @return {?}
     */
    static weekDay() {
        return moment().weekday();
    }
    /**
     * @return {?}
     */
    static currentMonth() {
        return moment().month() + 1;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Utils {
    /**
     * @param {?} value1
     * @param {?} value2
     * @return {?}
     */
    static equals(value1, value2) {
        value1 = Utils.notNullAndDefined(value1) ? value1 : '';
        value2 = Utils.notNullAndDefined(value2) ? value2 : '';
        if (value1 instanceof Date) {
            value1 = value1.getTime();
        }
        if (value2 instanceof Date) {
            value2 = value2.getTime();
        }
        return value1 === value2;
    }
    /**
     * @param {?} value1
     * @param {?} value2
     * @return {?}
     */
    static notEquals(value1, value2) {
        return Utils.isFalse(Utils.equals(value1, value2));
    }
    /**
     * @param {?} str1
     * @param {?} str2
     * @return {?}
     */
    static equalsIgnoreCase(str1, str2) {
        str1 = Utils.notNullAndDefined(str1) ? str1.toString().toLowerCase().trim() : '';
        str2 = Utils.notNullAndDefined(str2) ? str2.toString().toLowerCase().trim() : '';
        return str1 === str2;
    }
    /**
     * @param {?} value1
     * @param {?} value2
     * @return {?}
     */
    static notEqualsIgnoreCase(value1, value2) {
        return Utils.isFalse(Utils.equalsIgnoreCase(value1, value2));
    }
    /**
     * @param {?} mainText
     * @param {?} subText
     * @return {?}
     */
    static containsIgnoreCase(mainText, subText) {
        mainText = Utils.notNullAndDefined(mainText) ? mainText.toLowerCase().trim() : '';
        subText = Utils.notNullAndDefined(subText) ? subText.toLowerCase().trim() : '';
        return mainText.indexOf(subText) !== -1;
    }
    /**
     * @param {?} mainText
     * @param {?} subText
     * @return {?}
     */
    static startsWithIgnoreCase(mainText, subText) {
        mainText = Utils.notNullAndDefined(mainText) ? mainText.toLowerCase().trim() : '';
        subText = Utils.notNullAndDefined(subText) ? subText.toLowerCase().trim() : '';
        return mainText.startsWith(subText);
    }
    /**
     * @param {?} mainText
     * @param {?} subText
     * @return {?}
     */
    static endsWithIgnoreCase(mainText, subText) {
        mainText = Utils.notNullAndDefined(mainText) ? mainText.toLowerCase().trim() : '';
        subText = Utils.notNullAndDefined(subText) ? subText.toLowerCase().trim() : '';
        return mainText.endsWith(subText);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static isNullOrUndefined(value) {
        return (value === null ||
            value === 'null' ||
            value === undefined ||
            value === 'undefined' ||
            typeof value === 'undefined');
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static notNullAndDefined(value) {
        return Utils.isFalse(Utils.isNullOrUndefined(value));
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static isNullOrEmpty(value) {
        /** @type {?} */
        let isValid = Utils.isNullOrUndefined(value);
        if (Utils.isFalse(isValid)) {
            if (typeof value === 'string') {
                isValid = value.trim().length === 0;
            }
            else if (typeof value === 'number' || typeof value === 'bigint') {
                isValid = value === 0;
            }
            else if (value instanceof Date) {
                isValid = !value;
            }
            else if (typeof value === 'object') {
                isValid = Object.keys(value).length === 0;
            }
        }
        return isValid;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    static notNullOrEmpty(value) {
        return Utils.isFalse(Utils.isNullOrEmpty(value));
    }
    /**
     * @param {?} num
     * @return {?}
     */
    static isValidNumber(num) {
        return Utils.isFalse(Utils.isNullOrUndefined(num)) && Utils.isFalse(isNaN(num));
    }
    /**
     * @param {?} id
     * @return {?}
     */
    static isValidDtoId(id) {
        return Utils.isValidNumber(id) && id > 0;
    }
    /**
     * @param {?} id
     * @return {?}
     */
    static notValidDtoId(id) {
        return Utils.isFalse(Utils.isValidDtoId(id));
    }
    /**
     * @param {?} flag
     * @return {?}
     */
    static isTrue(flag) {
        return flag === true;
    }
    /**
     * @param {?} flag
     * @return {?}
     */
    static isFalse(flag) {
        return flag === false;
    }
    /**
     * @param {?} input
     * @return {?}
     */
    static isNull(input) {
        return input === null;
    }
    /**
     * @param {?} item
     * @param {?} items
     * @param {?=} fieldName
     * @return {?}
     */
    static isInList(item, items, fieldName = null) {
        return ((Utils.notNullAndDefined(fieldName)
            ? items.findIndex((/**
             * @param {?} r
             * @return {?}
             */
            (r) => Utils.equalsIgnoreCase(String(r[fieldName]), String(item[fieldName]))))
            : Utils.findIndexInList(item, items)) !== -1);
    }
    /**
     * @param {?} item
     * @param {?} items
     * @param {?=} fieldName
     * @return {?}
     */
    static notInList(item, items, fieldName = null) {
        return ((Utils.notNullAndDefined(fieldName)
            ? items.findIndex((/**
             * @param {?} r
             * @return {?}
             */
            (r) => Utils.equalsIgnoreCase(String(r[fieldName]), String(item[fieldName]))))
            : Utils.findIndexInList(item, items)) === -1);
    }
    /**
     * @param {?} items
     * @param {?=} fieldName
     * @return {?}
     */
    static uniqueList(items, fieldName = null) {
        /** @type {?} */
        const filterFn = (/**
         * @param {?} item
         * @param {?} index
         * @param {?} items
         * @return {?}
         */
        (item, index, items) => {
            return ((Utils.notNullAndDefined(fieldName)
                ? items.findIndex((/**
                 * @param {?} r
                 * @return {?}
                 */
                (r) => Utils.equalsIgnoreCase(String(r[fieldName]), String(item[fieldName]))))
                : Utils.findIndexInList(item, items)) === index);
        });
        return items.filter(filterFn);
    }
    /**
     * @param {?} item
     * @param {?} items
     * @return {?}
     */
    static findIndexInList(item, items) {
        if (typeof item === 'string') {
            return items.findIndex((/**
             * @param {?} r
             * @return {?}
             */
            (r) => Utils.equalsIgnoreCase(r, item)));
        }
        else {
            return items.indexOf(item);
        }
    }
    /**
     * @return {?}
     */
    static getUUID() {
        /** @type {?} */
        let dt = new Date().getTime();
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (/**
         * @param {?} c
         * @return {?}
         */
        (c) => {
            /** @type {?} */
            const r = (dt + Math.random() * 16) % 16 | 0;
            dt = Math.floor(dt / 16);
            return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
        }));
    }
    /**
     * @param {?} text
     * @return {?}
     */
    static getTitleCase(text) {
        /** @type {?} */
        const strList = text
            .toLowerCase()
            .split(' ')
            .map((/**
         * @param {?} d
         * @return {?}
         */
        (d) => {
            return `${d.charAt(0).toUpperCase()}${d.slice(1)}`;
        }));
        return strList.join(' ');
    }
    /**
     * @param {?} customerId
     * @return {?}
     */
    static isValidRNumber(customerId) {
        return Utils.notNullAndDefined(customerId) && /^R[0-9]{7}[U,L]{1}[0-9]{7}$/.test(customerId.toUpperCase());
    }
    /**
     * @param {?} items
     * @param {?} opts
     * @return {?}
     */
    static sortByMultipleFields(items, opts) {
        /** @type {?} */
        const sortFunction = (/**
         * @param {?} a
         * @param {?} b
         * @return {?}
         */
        (a, b) => {
            /** @type {?} */
            let i = 0;
            /** @type {?} */
            let result = 0;
            while (i < opts.length && result === 0) {
                /** @type {?} */
                let multiplier = 0;
                if (a[opts[i].field].toString() < b[opts[i].field].toString()) {
                    multiplier = -1;
                }
                else if (a[opts[i].field].toString() > b[opts[i].field].toString()) {
                    multiplier = 1;
                }
                result = opts[i].asc * multiplier;
                i++;
            }
            return result;
        });
        return items.sort(sortFunction);
    }
    /**
     * @param {?} items
     * @param {?} field
     * @param {?=} asc
     * @return {?}
     */
    static sortByField(items, field, asc = 1) {
        return Utils.sortByMultipleFields(items, [{ field, asc }]);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class ConvertUtils {
    /**
     * @param {?} num
     * @return {?}
     */
    static toRealNumber(num) {
        /** @type {?} */
        const exp = num.toExponential();
        /** @type {?} */
        const tokens = exp.split('e').map((/**
         * @param {?} n
         * @return {?}
         */
        (n) => Number(n)));
        /** @type {?} */
        let factor = 0;
        if (tokens[1] < 0) {
            factor = Math.abs(tokens[1]);
            factor += tokens[0].toString().replace('-', '').replace('.', '').length - 1;
        }
        else {
            /** @type {?} */
            const token = tokens[0].toString();
            if (token.indexOf('.') !== -1) {
                /** @type {?} */
                const decimalPlaces = token.split('.').reverse()[0].length;
                factor = Math.max(0, decimalPlaces - tokens[1]);
            }
        }
        return num.toFixed(factor);
    }
    /**
     * @param {?} value
     * @param {?=} precision
     * @return {?}
     */
    static toRoundedNumber(value, precision = 2) {
        /** @type {?} */
        let result = 0;
        if (!!value) {
            /** @type {?} */
            const realNumber = ConvertUtils.toRealNumber(value);
            /** @type {?} */
            const roundedNumber = Math.round(Number(`${realNumber}e${precision}`));
            result = Number(`${roundedNumber}e-${precision}`);
            if (result === -0) {
                result = 0;
            }
        }
        return result;
    }
    /**
     * @param {?} min
     * @param {?} max
     * @return {?}
     */
    static toRandomBetween(min, max) {
        /** @type {?} */
        let retVal = 0;
        if (!isNaN(min) && !isNaN(max) && max > min) {
            retVal = Math.floor(Math.random() * (max - min + 1)) + min;
        }
        return retVal;
    }
    /**
     * @param {?} value
     * @param {?=} separator
     * @return {?}
     */
    static stringToList(value, separator = '|') {
        return Utils.notNullAndDefined(value) ? value.split(separator) : [];
    }
    /**
     * @param {?} values
     * @param {?=} separator
     * @return {?}
     */
    static listToString(values, separator = '|') {
        return Utils.notNullOrEmpty(values) ? values.join(separator) : '';
    }
    /**
     * @param {?} customerId
     * @return {?}
     */
    static toPropertyId(customerId) {
        return Utils.isValidRNumber(customerId) ? parseInt(customerId.substring(9)) : null;
    }
    /**
     * @param {?} customerId
     * @return {?}
     */
    static toOwnerId(customerId) {
        return Utils.isValidRNumber(customerId) ? parseInt(customerId.substring(0, 8).replace('R', '')) : null;
    }
    /**
     * @param {?} customerId
     * @return {?}
     */
    static toPropertyTypeCode(customerId) {
        return Utils.isValidRNumber(customerId) ? (Utils.containsIgnoreCase(customerId, 'L') ? 'L' : 'U') : null;
    }
    // Expensive method. Must be used with caution
    /**
     * @param {?} items
     * @param {?=} idField
     * @param {?=} pidField
     * @param {?=} sortField
     * @return {?}
     */
    static toHierarchicalItems(items, idField = 'id', pidField = 'parentId', sortField = 'title') {
        /** @type {?} */
        const getChildren = (/**
         * @param {?} parentId
         * @return {?}
         */
        (parentId) => {
            /** @type {?} */
            const children = [];
            items.forEach((/**
             * @param {?} r
             * @return {?}
             */
            (r) => {
                if (r[pidField] === parentId) {
                    r.items = getChildren(r[idField]);
                    children.push(r);
                }
            }));
            return Utils.sortByField(children, sortField);
        });
        /** @type {?} */
        const results = [];
        items.forEach((/**
         * @param {?} r
         * @return {?}
         */
        (r) => {
            if (Utils.isNullOrEmpty(r[pidField])) {
                r.items = getChildren(r[idField]);
                results.push(r);
            }
        }));
        return results;
    }
    // Check for empty string and return null if empty string
    /**
     * @param {?} value
     * @return {?}
     */
    static toNullableString(value) {
        return Utils.notNullOrEmpty(value) ? value : null;
    }
    // Date object to date only string
    /**
     * @param {?} value
     * @return {?}
     */
    static toDateString(value) {
        return Utils.notNullAndDefined(value) ? DateUtils.dateToString(value, 'YYYY-MM-DD') : value;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DxWidgetUtils {
    /**
     * @param {?} widget
     * @return {?}
     */
    static hasInstance(widget) {
        return Utils.notNullAndDefined(widget) && Utils.notNullAndDefined(widget.instance);
    }
    /**
     * @param {?} widget
     * @return {?}
     */
    static instantRepaint(widget) {
        if (DxWidgetUtils.hasInstance(widget)) {
            widget.instance.repaint();
        }
    }
    /**
     * @param {?} widget
     * @param {?} ms
     * @return {?}
     */
    static deferredRepaint(widget, ms) {
        return setTimeout(DxWidgetUtils.instantRepaint, ms, [widget]);
    }
    /**
     * @param {?} widget
     * @return {?}
     */
    static instantRefresh(widget) {
        if (DxWidgetUtils.hasInstance(widget)) {
            widget.instance.refresh();
        }
    }
    /**
     * @param {?} widget
     * @param {?} ms
     * @return {?}
     */
    static deferredRefresh(widget, ms) {
        return setTimeout(DxWidgetUtils.instantRefresh, ms, [widget]);
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { APP_VERSION, AddNewRowDirective, AuthConstants, CCCalculatorModule, CCCommonComponent, CCCommonModule, CCCommonService, CCDataGridFeatures, CCDataGridFeaturesModule, CCDataGridPagingConfig, CCDataGridStateConfig, CCDeviceService, CCLocalStorageCategory, CCLocalStorageParameterDto, CCLocalStorageRawDto, CCLocalStorageService, CCMessageBoxIcon, CCPasswordHelperService, CCScreenService, CCSessionManagerService, CCTimeZoneService, CCTokenRenewalService, CalculatorComponent, CalendarExportContants, ConvertUtils, DataGridFeaturesComponent, DateUtils, DxWidgetUtils, IconConstants, ImageEditorComponent, MessageBoxComponent, PhoneNumberPipe, PreventCopyPasteDirective, PrintableCharsPipe, SafeHtmlPipe, SafeUrlPipe, SwitchComponent, TimezoneConstants, TrimInputDirective, UtcToUserTimezoneDatePipe, UtcToUserTimezonePipe, Utils, WebCamComponent, ZoneNamePipe, DataGridPagerComponent as ɵa };
//# sourceMappingURL=cc-common.js.map
